import { CardConfig } from '@affinis/smartus-components/lib/card/card.component.types';
import { Tab } from '@affinis/smartus-components/lib/tabs/tabs.components.types';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FmConfigurationRow,
  FileClient,
  FmIncident,
  FmIncidentServiceLine,
  FmPurchaseOrder,
  FmQuotationLine,
  FmQuotationRequestLine,
  FmTask,
  FmUnit,
  FrameworkContractClient,
  IncidentClient,
  IncidentFieldMapping,
  IncidentServiceLineUpdate,
  LocationClient,
  OptionSetClient,
  OrganisationClient,
  PmIncidentExternalLetting,
  PmIncidentRealEstateDecision,
  PmIncidentRentalContractMgmt,
  Quotation,
  QuotationClient,
  QuotationLine,
  ResultExtensionWrapperOfTaskViewModelAndIEnumerableOfIncidentFieldMapping,
  SendIncidentCommunicationRequest,
  SubIncidentViewModel,
  SysEnum,
  TaskClient,
  TaskStatus,
  UnitClient,
  UpdateIncidentDTO,
  UpdateIncidentServiceLinesRequest,
  UpdateTaskDTO,
} from '@core/api';
import {
  CheckForTaskUpdateRequest,
  FmQuotation,
  ServiceRegistrationClient,
  UpdateServiceRegistrationLine,
  UpdateServiceRegistrationRequest,
  UploadFile,
} from '@core/api/smart-portal.api';
import { BreadcrumbService } from '@core/services/breadcrumb-service/BreadcrumbService';
import { OrganisationSearchFormlyFieldService } from '@core/services/organisation-search-formly-field-service/organisation-search-formly-field.service';
import { IncidentClass } from '@core/services/ticket-list-desk-service/incidentClass';
import { IbpdiHelperService } from '@core/services/translate-service/ibpdi-helper.service';
import { TranslateDataService } from '@core/services/translate-service/translate-data.service';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { IDetailFields } from '@shared/components/details/detail-fields/models/detail-fields.model';
import { DialogComponent } from '@shared/components/dialog/dialog.component';
import { DocumentType, DocumentVisibility } from '@shared/types/document.types';
import { cloneDeep, isEqual } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import {
  catchError,
  finalize,
  first,
  firstValueFrom,
  forkJoin,
  from,
  map,
  Observable,
  of,
  shareReplay,
  switchMap,
  take,
} from 'rxjs';
import { ProspectiveTenantsTelekomComponent } from '../prospective-tenants/prospective-tenants.component';
import { SERVICE_LINE_COLUMNS } from '@shared/constants/grid-columns.constants';
import {
  FormOverrides,
  TaskExcelExportService,
} from '@core/services/excel-export-service/task-excel-export.service';
import { TaskSubject } from '@shared/constants/taskSubjects.constants';
import { SubmitOfferDialogComponent } from '../submit-offer-dialog/submit-offer-dialog.component';
import { PreviousOffersDialogComponent } from '../previous-offers-dialog/previous-offers-dialog.component';
import moment from 'moment';
import { QuotationTypes } from '@shared/constants/quotation-types.constants';
import { formatPrice } from '@shared/utils/price-formatter';
import {
  getServiceRegistrationDocumentsByQuotationLineId,
  prepareServiceRegistrationLocations,
} from '@shared/utils/service-registration.utils';
import {
  buildTaskTooltipKey,
  getIncidentQuotationsFromTask,
  getLatestAcceptedAddendumQuotationFromTask,
  getLatestAddendumQuotationFromTask,
  getLatestAddendumQuotationLinesFromTask,
  getLatestAddendumStatusReasonFromTask,
  isAcceptedAddendumStatusReasonValue,
  isAddendumQuotationByType,
  translateIfTooltipKey,
} from '@shared/utils/task-offer.utils';
import { TaskLayoutService } from './services/task-layout.service';
import {
  StatusOptionsContext,
  TaskStatusOptionsService,
} from './services/task-status-options.service';
import { TaskEquipmentService } from './services/task-equipment.service';
import { TaskQuotationService } from './services/task-quotation.service';

interface IContactForm {
  subject: string;
  content: string;
}

@Component({
  selector: 'app-task-details',
  templateUrl: './task-details.component.html',
  styleUrls: ['./task-details.component.scss'],
  standalone: false,
  providers: [
    TaskLayoutService,
    TaskStatusOptionsService,
    TaskEquipmentService,
    TaskQuotationService,
  ],
})
export class TaskDetailsTelekomComponent implements OnInit {
  cardFields: CardConfig;

  cardDocumentupload: CardConfig;

  cardContact: CardConfig;

  cardContactUs: CardConfig = {
    footer: {
      button1: {
        label: this.translateService.instant('form.submit'),
        disabled: false,
        onClick: () => {
          this.validateForm();
        },
      },
    },
  };

  formContactUs = new FormGroup({});
  formFieldsContactUs: Array<FormlyFieldConfig> = [];
  formModelContactUs = {} as IContactForm;

  dataContactAddress: FmIncident;

  isOPLExt = false;
  canDownload = true;
  isDummyFrameworkContract = false;
  private readonly task7CompletedResultText =
    'Leistungserfassung abgeschlossen';
  private readonly defaultEquipmentDocumentTypeName = 'KGR 400-499 Prüfbericht';
  private lastTask7SelectedStatus: TaskStatus | string | null = null;
  private hasSubmittedAddendumOfferLocally = false;
  private task7AutoCloseTriggered = false;
  private isPreviousOffersDialogOpening = false;
  private previousOffersDialogRef: MatDialogRef<PreviousOffersDialogComponent> | null =
    null;

  tooltipSelectDocument: string;
  tooltipUploadDocument: string;

  readonly task3And7AllowedFileExtensions: string[] = [
    '.jpg',
    '.jpeg',
    '.png',
    '.pdf',
    '.txt',
    '.tif',
    '.tiff',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.ppt',
    '.pptx',
    '.msg',
    '.zip',
  ];

  get canShowAddPurchaseResultsButton(): boolean {
    return this.isTask2EvaluateOffersAndCreateSuppliers;
  }

  get isTask2_3_7_11(): boolean {
    return (
      this.isTask2EvaluateOffersAndCreateSuppliers ||
      this.isTask3EvaluateOfferInquiry ||
      this.isTask7ExecuteOptionalService ||
      this.isTask11SubmitInvoiceToScanCenter
    );
  }

  get hasTask3And7UploadRestrictions(): boolean {
    return (
      this.isTask3EvaluateOfferInquiry || this.isTask7ExecuteOptionalService
    );
  }

  get taskSubjectHeadline(): string {
    return this.task?.subject ?? this.formModel?.subject ?? '';
  }

  get canShowOrderedAddendumQuotationButton(): boolean {
    if (!this.isTask7ExecuteOptionalService) {
      return false;
    }

    return !!this.getLatestAcceptedAddendumQuotation();
  }

  get hasExistingAddendumOffer(): boolean {
    if (!this.isTask7ExecuteOptionalService) {
      return false;
    }

    if (this.hasSubmittedAddendumOfferLocally) {
      return true;
    }

    return this.getIncidentQuotations().some(quotation =>
      this.isAddendumQuotation(quotation)
    );
  }

  get saveButtonTooltip(): string | undefined {
    if (
      !this.isTask2EvaluateOffersAndCreateSuppliers &&
      !this.isTask3EvaluateOfferInquiry &&
      !this.isTask7ExecuteOptionalService &&
      !this.isTask11SubmitInvoiceToScanCenter
    ) {
      return undefined;
    }

    const selectedStatus =
      this.form?.get('newStatus')?.value ?? this.formModel?.newStatus;

    if (selectedStatus === TaskStatus.InBearbeitung) {
      return this.translateService.instant(
        'taskmodule.task.offer.tooltip.saveButton.in_progress'
      );
    }

    if (selectedStatus === TaskStatus.Abgeschlossen) {
      return this.translateService.instant(
        'taskmodule.task.offer.tooltip.saveButton.completed'
      );
    }

    if (selectedStatus === TaskStatus.Storniert) {
      return this.translateService.instant(
        'taskmodule.task.offer.tooltip.saveButton.denied'
      );
    }

    return undefined;
  }

  get isWideLayout(): boolean {
    return this.layoutService.isWideLayout;
  }

  get buttonMaxWidthTitle(): string {
    return this.layoutService.buttonMaxWidthTitle;
  }

  toggleWideLayout(): void {
    this.layoutService.toggle();
  }

  units: FmUnit[] = [];
  frameworkContractLineItems: any[] = [];

  description = '';
  descriptionStyle: string;
  descriptionContainerStyle: string;

  tabs: Tab[] = [
    {
      label: 'Ticketfelder bearbeiten',
      id: 'editIncidentFields',
      onClick: (id: string) => this.onTabClick(id),
    },
    {
      label: 'Dokumente',
      id: 'documents',
      onClick: (id: string) => this.onTabClick(id),
    },
    {
      label: 'Kontakt',
      id: 'contact',
      onClick: (id: string) => this.onTabClick(id),
    },
  ];

  activeTab = this.tabs[0].id;

  onTabClick(value: string) {
    this.activeTab = value;
  }

  private isTask7ResultEditableForStatus(
    status?: TaskStatus | string | null
  ): boolean {
    if (!this.isTask7ExecuteOptionalService) {
      return true;
    }

    return status === TaskStatus.Abgeschlossen;
  }

  private syncTask7ResultFieldState(status?: TaskStatus | string | null): void {
    if (!this.isTask7ExecuteOptionalService) {
      return;
    }

    const resultControl = this.form.get('result') as any;
    if (!resultControl) {
      return;
    }

    const normalizedStatus = status ?? null;
    const wasEditable = this.isTask7ResultEditableForStatus(
      this.lastTask7SelectedStatus
    );
    const isEditable = this.isTask7ResultEditableForStatus(normalizedStatus);

    if (!isEditable) {
      if (wasEditable) {
        const baselineResult = this.formModelInit?.result ?? '';
        resultControl.setValue(baselineResult, { emitEvent: false });
        if (this.formModel) {
          this.formModel.result = baselineResult;
        }
      }

      if (resultControl.enabled) {
        resultControl.disable({ emitEvent: false });
      }
      this.lastTask7SelectedStatus = normalizedStatus;
      return;
    }

    if (resultControl.disabled) {
      resultControl.enable({ emitEvent: false });
    }

    const currentValue = String(resultControl.value ?? '').trim();
    if (!currentValue) {
      resultControl.setValue(this.task7CompletedResultText, {
        emitEvent: false,
      });
      if (this.formModel) {
        this.formModel.result = this.task7CompletedResultText;
      }
    }

    this.lastTask7SelectedStatus = normalizedStatus;
  }

  locations:
    | FmIncidentServiceLine[]
    | FmQuotationRequestLine[]
    | FmQuotationLine[] = [];
  serviceRegistrationLocations: any[] = [];
  editedLocations:
    | FmIncidentServiceLine[]
    | FmQuotationRequestLine[]
    | FmQuotationLine[] = [];
  showEditedLocations = false;

  serviceLineColumns = SERVICE_LINE_COLUMNS;

  public isLoading = false;
  public isEquipmentDocumentationUploading = false;

  public masterRequired = true;

  form = new FormGroup({});

  formModel: any = {};

  formFields: FormlyFieldConfig[];

  entity: ResultExtensionWrapperOfTaskViewModelAndIEnumerableOfIncidentFieldMapping;

  task?: FmTask;

  extension?: IncidentFieldMapping[];

  private updateIncidentFieldGroupName = 'updateIncidentFieldsFormlyGroup';
  private updateIncidentExternalLetting =
    'updateIncidentExternalLettingFieldsFormlyGroup';
  private updateIncidentRealEstateDecision =
    'updateIncidentRealEstateDecisionFieldsFormlyGroup';
  private updateIncidentRentalContractMngmnt =
    'updateIncidentRentalContractMngmntFieldsFormlyGroup';

  isSaveButtonEnabled = false;

  private organisationMap = new Map<string, string>();
  private formatOrganisationLabel(org?: any): string {
    return [
      org?.name,
      org?.id ?? org?.organisationId,
      org?.address?.city,
      org?.address?.postalCode,
      org?.address?.streetName,
    ]
      .filter(Boolean)
      .join(', ');
  }

  private organisations$ = this.organisationClient
    .getAdminPortalRelevantOrSupplier()
    .pipe(
      map(orgs => {
        orgs.forEach(org => {
          if (org.id && org.name) {
            this.organisationMap.set(org.id, org.name);
          }
        });
        return orgs;
      }),
      shareReplay(1)
    );

  incidentInformations: FormlyFieldConfig[] = [
    {
      wrappers: ['card'],
      fieldGroup: [
        {
          type: 'flex-layout',
          fieldGroup: [
            {
              key: 'incident.ticketNumber',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__ticketNumber'),
                readOnly: true,
              },
            },
            {
              key: 'incident.requestType',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentType'),
                readOnly: true,
              },
            },
          ],
        },
        {
          type: 'flex-layout',
          fieldGroup: [
            {
              key: 'incident.name',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentTitle'),
                readOnly: true,
              },
            },
            {
              key: 'incident.incidentClass.incidentClass',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentClass'),
                readOnly: true,
              },
            },
          ],
        },
        {
          type: 'flex-layout',
          fieldGroup: [
            {
              key: 'incident.archObjId',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentFunctionalLocation'),
                readOnly: true,
              },
            },
            {
              key: 'incident.dtagResponsibility',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentDtagResponsibility'),
                readOnly: true,
              },
            },
          ],
        },
      ],
    },
  ];

  taskInformations: FormlyFieldConfig[] = [];

  incidentOPLExtInformations: FormlyFieldConfig[] = [
    {
      wrappers: ['card'],
      fieldGroup: [
        {
          type: 'flex-layout',
          fieldGroup: [
            {
              key: 'incident.ticketNumber',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__ticketNumber'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.ticketNumber'
                ),
                readOnly: true,
              },
            },
            {
              key: 'incident.requestType',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentType'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.incidentType'
                ),
                readOnly: true,
              },
            },
            {
              key: 'incident.name',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentTitle'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.incidentTitle'
                ),
                readOnly: true,
              },
            },
            {
              key: 'incident.description',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incident_description'),
                readOnly: true,
              },
              expressions: {
                'props.tooltip': () =>
                  this.translateIfKey(
                    this.getTaskTooltipKey('incidentDescription')
                  ),
              },
            },
            {
              key: 'incident.incidentClass.incidentClass',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentClass'),
                readOnly: true,
              },
              expressions: {
                'props.tooltip': () =>
                  this.translateIfKey(this.getTaskTooltipKey('incidentClass')),
              },
            },
          ],
        },
        {
          type: 'flex-layout',
          fieldGroup: [
            {
              key: 'incident.product.name',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__productName'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.productName'
                ),
                readOnly: true,
              },
            },
            {
              key: 'incident.product.description',
              type: 'input',
              wrappers: ['readOnly'],
              hideExpression: () => this.isTask2_3_7_11,
              props: {
                label: this.translate('label__productDescription'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.productDescription'
                ),
                readOnly: true,
              },
            },
          ],
        },
        {
          type: 'flex-layout',
          fieldGroup: [
            {
              key: 'reporterFullName',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__reporter'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.reporter'
                ),
                readOnly: true,
              },
              expressions: {
                'model.reporterFullName': field => {
                  const firstname =
                    field.model?.incident?.fmServiceRequestExternal?.creator
                      ?.firstname || '';
                  const lastname =
                    field.model?.incident?.fmServiceRequestExternal?.creator
                      ?.lastname || '';
                  return `${firstname} ${lastname}`.trim();
                },
              },
            },
            {
              key: 'incident.fmServiceRequestExternal.purchasingInformation',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__purchasingInformation'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.purchasingInformation'
                ),
                readOnly: true,
              },
              hideExpression: () =>
                !this.isTask2EvaluateOffersAndCreateSuppliers,
            },
            {
              key: 'serviceProviderSelection',
              fieldGroup: [
                ...this.organisationFormlyFieldService.autocompleteSearch(
                  this.translate('label__supplier_select'),
                  this.organisations$,
                  (_id, _initialSearch, value: any) => {
                    if (value?.id && value?.name) {
                      this.organisationMap.set(value.id, value.name);

                      const serviceProvider =
                        this.formModel?.incident?.fmServiceRequestExternal
                          ?.frameworkContract?.serviceProvider;
                      if (serviceProvider) {
                        serviceProvider.name =
                          this.formatOrganisationLabel(value);
                      }
                    }
                  },
                  true,
                  false,
                  true,
                  () => {
                    const serviceProvider =
                      this.formModel?.incident?.fmServiceRequestExternal
                        ?.frameworkContract?.serviceProvider;
                    if (serviceProvider) {
                      serviceProvider.name = '';
                    }
                  }
                ),
              ],
              expressions: {
                'fieldGroup[0].props.required': field => {
                  const newStatus =
                    field?.form?.get('newStatus')?.value ??
                    field?.model?.newStatus;
                  return newStatus !== TaskStatus.Storniert;
                },
                'model.incident.fmServiceRequestExternal.frameworkContract.serviceProvider.name':
                  field => {
                    const selectedValue =
                      field.model?.serviceProviderSelection?.searchResult;
                    return selectedValue
                      ? this.formatOrganisationLabel(selectedValue)
                      : '';
                  },
              },
              hideExpression: () =>
                !this.isTask2EvaluateOffersAndCreateSuppliers,
            },
            {
              key: 'incident.fmServiceRequestExternal.frameworkContract.serviceProvider.name',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__supplier'),
                readOnly: true,
              },
              expressions: {
                'model.incident.fmServiceRequestExternal.frameworkContract.serviceProvider.name':
                  field => {
                    const selectedValue =
                      field.model?.serviceProviderSelection?.searchResult;
                    return selectedValue
                      ? this.formatOrganisationLabel(selectedValue)
                      : field.model?.incident?.fmServiceRequestExternal
                          ?.frameworkContract?.serviceProvider?.name || '';
                  },
                'props.tooltip': () =>
                  this.translateIfKey(this.getTaskTooltipKey('supplier')),
              },
            },
            {
              key: 'incident.fmServiceRequestExternal.deliveryTargetDate',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__deliveryTargetDate'),
                readOnly: true,
                valueFormatter: (date: string) => {
                  if (!date) {
                    return '--';
                  }
                  return this.formatDateString(new Date(date));
                },
              },
              expressions: {
                'props.tooltip': () =>
                  this.translateIfKey(
                    this.getTaskTooltipKey('deliveryTargetDate')
                  ),
              },
            },
            {
              key: 'incident.fmServiceRequestExternal.priority.defaultName',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__priority'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.priority'
                ),
                readOnly: true,
              },
            },
            {
              key: 'incident.fmServiceRequestExternal.offerComment',
              type: 'input',
              wrappers: ['readOnly'],
              hideExpression: model =>
                this.isTask2EvaluateOffersAndCreateSuppliers ||
                this.isTask7ExecuteOptionalService ||
                !String(
                  model?.incident?.fmServiceRequestExternal?.offerComment ?? ''
                ).trim() ||
                this.isTask11SubmitInvoiceToScanCenter,
              props: {
                label: this.translate('label__offerComment'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.offerComment'
                ),
                readOnly: true,
              },
            },
            {
              key: 'incident.fmServiceRequestExternal.auxilaryAccountAssignment.value',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__auxilaryAccountAssignment'),
                readOnly: true,
              },
              hideExpression: () =>
                this.isTask2EvaluateOffersAndCreateSuppliers ||
                this.isTask3EvaluateOfferInquiry ||
                this.isTask7ExecuteOptionalService ||
                this.isTask11SubmitInvoiceToScanCenter,
            },
          ],
        },
      ],
    },
  ];

  taskOPLExtInformations: FormlyFieldConfig[] = [
    {
      key: 'subject',
      type: 'input',
      wrappers: ['readOnly'],
      props: {
        label: this.translate('label__subject'),
        tooltip: this.translateService.instant(
          'taskmodule.task.offer.tooltip.subject'
        ),
        readOnly: true,
      },
    },
    {
      wrappers: ['form-field', 'count-chars'],
      key: 'result',
      type: 'textarea',
      props: {
        label: this.translate('label__result'),
        visibleInConfirm: true,
        required: this.masterRequired,
        autosize: true,
        autosizeMinRows: 4,
        maxLength: 2000,
      },
      expressions: {
        'props.required': field => {
          if (!this.isTask7ExecuteOptionalService) {
            return this.masterRequired;
          }

          const selectedStatus =
            field?.form?.get('newStatus')?.value ?? this.formModel?.newStatus;

          return selectedStatus === TaskStatus.Abgeschlossen;
        },
        'props.disabled': field => {
          const selectedStatus =
            field?.form?.get('newStatus')?.value ?? this.formModel?.newStatus;

          return !this.isTask7ResultEditableForStatus(selectedStatus);
        },
      },
      hooks: {
        onInit: field => {
          Promise.resolve().then(() => {
            const selectedStatus =
              field?.form?.get('newStatus')?.value ?? this.formModel?.newStatus;
            this.syncTask7ResultFieldState(selectedStatus);
          });

          field?.formControl?.valueChanges.subscribe(() => {
            if (!this.isTask7ExecuteOptionalService) {
              return;
            }
          });
        },
      },
    },
    {
      key: 'validUntil',
      type: 'datepicker',
      props: {
        label: this.translateService.instant(
          'taskmodule.task.offer.offer_validity_period'
        ),
        datepickerOptions: {
          min: new Date(),
        },
      },
      expressions: {
        'props.required': field => {
          const selectedStatus =
            field?.form?.get('newStatus')?.value ?? this.formModel?.newStatus;
          return (
            this.showEditedLocations && selectedStatus !== TaskStatus.Storniert
          );
        },
      },
      hideExpression: () => !this.isTask3EvaluateOfferInquiry,
    },
    {
      key: 'status',
      type: 'input',
      wrappers: ['readOnly'],
      props: {
        label: this.translate('label__actualStatus'),
        tooltip: this.translateService.instant(
          'taskmodule.task.offer.tooltip.actualStatus'
        ),
        readOnly: true,
      },
    },
    {
      type: 'select',
      key: 'newStatus',
      props: {
        label: this.translate('label__newStatus'),
        required: this.masterRequired,
        options: this.getNewStatusOptions(),
        compareWith(o1: any, o2: any) {
          if (o1 === o2) {
            return true;
          }

          if (o1 == null || o2 == null) {
            return false;
          }

          const value1 = typeof o1 === 'object' ? (o1.id ?? o1.value) : o1;
          const value2 = typeof o2 === 'object' ? (o2.id ?? o2.value) : o2;

          return value1 === value2;
        },
      },
      expressions: {
        'props.options': () => this.getNewStatusOptions(),
      },
      hooks: {
        onInit: field => {
          field?.formControl?.markAsTouched();
          Promise.resolve().then(() => {
            const selectedStatus =
              field?.formControl?.value ?? this.formModel?.newStatus;
            this.syncTask7ResultFieldState(selectedStatus);
          });
          field?.formControl?.valueChanges.subscribe({
            next: value => {
              if (this.task?.configurationTask?.fmConfigurationRow) {
                const formGroup =
                  this.formFields[
                    this.formFields.findIndex(
                      x => x.key === this.updateIncidentFieldGroupName
                    )
                  ];
                for (const row of this.task.configurationTask
                  .fmConfigurationRow) {
                  if (row.name) {
                    const key = this.firstLowercase(row.name);
                    if (formGroup?.fieldGroup) {
                      const formField =
                        formGroup.fieldGroup[
                          formGroup?.fieldGroup?.findIndex(x => x.key === key)
                        ];
                      if (formField?.props?.required !== undefined) {
                        formField.props.required =
                          value === TaskStatus.Abgeschlossen;
                      }
                    }
                  }
                }
              }

              this.syncTask7ResultFieldState(value);
              this.modelOnChange();
            },
          });
        },
      },
    },
  ];

  detailFields: IDetailFields[] = [
    {
      type: 'field',
      key: 'incident.name',
      label: this.translate('label__title'),
      tooltip: this.translateService.instant(
        'taskmodule.task.documents.tooltip.title'
      ),
    },
    {
      type: 'field',
      key: 'incident.ticketNumber',
      label: this.translate('label__ticketNumber'),
      tooltip: this.translateService.instant(
        'taskmodule.task.documents.tooltip.ticketNumber'
      ),
    },
    {
      type: 'field',
      key: 'subject',
      label: this.translate('label__subject'),
      tooltip: this.translateService.instant(
        'taskmodule.task.documents.tooltip.subject'
      ),
    },
    {
      type: 'buffered-files',
      key: 'documentMetadata',
    },
    {
      type: 'typed-files',
      key: 'fmDocument',
      options: [
        {
          label: 'Flurstückskarte',
          value: DocumentType.AmtlicheUnterlagenGrundstueck,
        },
        {
          label: 'Grundbuchauszug',
          value: DocumentType.AmtlicheUnterlagenGrundstueck,
        },
        { label: 'Pläne', value: DocumentType.Plaene },
        { label: 'Schriftverkehr', value: DocumentType.Schriftverkehr },
        { label: 'Sonstiges', value: DocumentType.Sonstiges },
      ],
    },
  ];

  dataProspectiveTenantsList$: Observable<SubIncidentViewModel[]>;

  displayedColumns: string[] = [
    'ticketNumber',
    'requestedArea',
    'requestedParkingSpace',
    'ticketStatusReason',
  ];

  private formModelInit;
  private editedLocationsInit:
    | FmIncidentServiceLine[]
    | FmQuotationRequestLine[]
    | FmQuotationLine[] = [];
  private serviceRegistrationLocationsInit: any[] = [];

  navigation = this.router.getCurrentNavigation();

  originRoute: string;

  isTask2EvaluateOffersAndCreateSuppliers: boolean; // Aufgabe 2: 2. Einkauf einbinden und Direktanfrage durchführen
  isTask3EvaluateOfferInquiry: boolean; // Aufgabe 3: 3. Angebotsanfrage erhalten und Angebot erstellen
  isTask7ExecuteOptionalService: boolean; // Aufgabe 7: 7. Optionale Leistung ext. durchführen
  isTask11SubmitInvoiceToScanCenter: boolean; // Aufgabe 11: 11. Rechnung an Scanzentrum übermitteln
  isTask2LineItemsEditable = false;
  isServiceRegistrationModeActive = false;

  constructor(
    private route: ActivatedRoute,
    private optionSetClient: OptionSetClient,
    private cd: ChangeDetectorRef,
    private translateDataService: TranslateDataService,
    private translateService: TranslateService,
    private taskClient: TaskClient,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private ibpdiHelperService: IbpdiHelperService,
    private locationClient: LocationClient,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    private incidentClient: IncidentClient,
    private taskExcelExportService: TaskExcelExportService,
    private organisationClient: OrganisationClient,
    private organisationFormlyFieldService: OrganisationSearchFormlyFieldService,
    private quotationClient: QuotationClient,
    private unitClient: UnitClient,
    private frameworkContractClient: FrameworkContractClient,
    private fileClient: FileClient,
    private serviceRegistrationClient: ServiceRegistrationClient,
    private layoutService: TaskLayoutService,
    private statusOptionsService: TaskStatusOptionsService,
    private equipmentService: TaskEquipmentService,
    private quotationService: TaskQuotationService
  ) {
    if (this.navigation?.extras?.state) {
      this.originRoute = this.navigation.extras.state?.originRoute;
    }
  }

  private handleEquipmentDocumentationUploaded(
    uploadResult: any
  ): Promise<void> {
    const taskId = this.task?.taskId;

    if (!taskId) {
      return Promise.resolve();
    }

    const uploadedDocuments = this.normalizeUploadedDocuments(uploadResult);
    const expectedDocumentIds = this.extractDocumentIds(uploadedDocuments);

    return this.refreshTaskDocumentsAfterEquipmentDocumentationUpload(
      taskId,
      uploadedDocuments,
      expectedDocumentIds
    );
  }

  private async refreshTaskDocumentsAfterEquipmentDocumentationUpload(
    taskId: string,
    uploadedDocuments: any[],
    expectedDocumentIds: string[]
  ): Promise<void> {
    const taskDocuments = await this.getTaskDocumentsWithRetry(
      taskId,
      expectedDocumentIds
    );

    if (!this.task) {
      return;
    }

    const mergedTaskDocuments = this.mergeDocumentsByDocumentId(
      taskDocuments,
      uploadedDocuments
    );
    const bufferedDocuments = this.mergeDocumentsByDocumentId(
      (this.task as any)?.documentMetadata || [],
      uploadedDocuments
    );

    this.task = {
      ...this.task,
      fmDocument: [...mergedTaskDocuments],
      documentMetadata: [...(bufferedDocuments || [])],
    } as any;

    if (this.entity?.entity) {
      this.entity = {
        ...this.entity,
        entity: this.task,
      };
    }

    this.formModel = {
      ...this.formModel,
      fmDocument: [...mergedTaskDocuments],
      documentMetadata: [...(bufferedDocuments || [])],
    };

    this.updateEquipmentByArchObjIdInAllFieldProps();
    this.cd.detectChanges();
  }

  private updateEquipmentByArchObjIdInAllFieldProps(): void {
    if (!this.task) {
      return;
    }

    const updatedEquipmentByArchObjId =
      this.equipmentService.buildEquipmentByArchObjId(this.task);

    const traverse = (fields: FormlyFieldConfig[]): void => {
      for (const field of fields || []) {
        if (field.props && 'equipmentByArchObjId' in field.props) {
          field.props['equipmentByArchObjId'] = updatedEquipmentByArchObjId;
        }
        if (field.fieldGroup?.length) {
          traverse(field.fieldGroup);
        }
      }
    };

    traverse(this.formFields);
  }

  private async getTaskDocumentsWithRetry(
    taskId: string,
    expectedDocumentIds: string[],
    maxAttempts = 8,
    delayMs = 1000
  ): Promise<any[]> {
    let latestDocuments: any[] = [];

    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      try {
        latestDocuments =
          (await firstValueFrom(this.fileClient.getTaskDocuments(taskId))) ||
          [];

        const hasAllExpected = this.hasAllExpectedDocuments(
          latestDocuments,
          expectedDocumentIds
        );

        if (hasAllExpected || attempt === maxAttempts) {
          return latestDocuments;
        }
      } catch {
        if (attempt === maxAttempts) {
          return latestDocuments;
        }
      }

      await this.delay(delayMs);
    }

    return latestDocuments;
  }

  private hasAllExpectedDocuments(
    taskDocuments: any[],
    expectedDocumentIds: string[]
  ): boolean {
    if (!expectedDocumentIds.length) {
      return true;
    }

    const documentIds = new Set(
      (taskDocuments || [])
        .map((document: any) => this.getDocumentId(document))
        .filter((documentId: string) => !!documentId)
    );

    return expectedDocumentIds.every(documentId => documentIds.has(documentId));
  }

  private extractDocumentIds(uploadedDocuments: any[]): string[] {
    return (uploadedDocuments || [])
      .map(item => this.getDocumentId(item))
      .filter((documentId: string) => !!documentId);
  }

  private normalizeUploadedDocuments(uploadResult: any): any[] {
    if (Array.isArray(uploadResult)) {
      return uploadResult;
    }

    if (Array.isArray(uploadResult?.documents)) {
      return uploadResult.documents;
    }

    if (Array.isArray(uploadResult?.documentMetadata)) {
      return uploadResult.documentMetadata;
    }

    return [];
  }

  private mergeDocumentsByDocumentId(
    baseDocuments: any[],
    additionalDocuments: any[]
  ): any[] {
    const merged = [...(baseDocuments || []), ...(additionalDocuments || [])];
    const byKey = new Map<string, any>();

    for (const [index, document] of merged.entries()) {
      const key =
        this.getDocumentMergeKey(document) || `fallback-index:${index}`;
      const existing = byKey.get(key);
      if (!existing) {
        byKey.set(key, document);
      } else {
        byKey.set(key, {
          ...existing,
          ...document,
          filename:
            this.getDocumentFileName(document) ||
            this.getDocumentFileName(existing),
          name:
            this.getDocumentDisplayName(document) ||
            this.getDocumentDisplayName(existing),
        });
      }
    }

    return Array.from(byKey.values());
  }

  private getDocumentMergeKey(document: any): string {
    const documentId = this.getDocumentId(document);
    if (documentId) {
      return `id:${documentId}`;
    }

    const incidentEquipmentId = this.getDocumentIncidentEquipmentId(document);
    const fileName = this.getDocumentFileName(document);
    const documentTypeId = this.getDocumentTypeId(document);

    if (!incidentEquipmentId && !fileName) {
      return '';
    }

    return `fallback:${incidentEquipmentId}:${fileName}:${documentTypeId}`;
  }

  private getDocumentId(document: any): string {
    return String(
      document?.documentId || document?.metadata?.documentId || ''
    ).trim();
  }

  private getDocumentIncidentEquipmentId(document: any): string {
    return String(
      document?.incidentEquipmentId ||
        document?.metadata?.incidentEquipmentId ||
        ''
    ).trim();
  }

  private getDocumentTypeId(document: any): string {
    return String(
      document?.documentTypeId || document?.metadata?.documentTypeId || ''
    ).trim();
  }

  private getDocumentFileName(document: any): string {
    return String(
      document?.filename ||
        document?.metadata?.filename ||
        document?.name ||
        document?.metadata?.name ||
        ''
    ).trim();
  }

  private getDocumentDisplayName(document: any): string {
    return String(document?.name || document?.metadata?.name || '').trim();
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  ngOnInit() {
    this.layoutService.restorePreference();

    this.organisations$.pipe(first()).subscribe();

    this.initializeContactUsForm();
    this.description = this.translateService.instant(
      'ticket.summary.contact.hint'
    );
    this.descriptionStyle =
      'background-color: #E20074; color: white; border-radius: 5px; padding: 15px;';
    this.descriptionContainerStyle =
      'width: 100%; max-width: 840px; border-radius: 15px; padding: 0 15px;';

    this.getItem(this.route.snapshot.paramMap.get('id'));
    let label = this.translateService.instant(
      'menu.tickets_tasks.component.tasks_view'
    );
    let route = '/tasks';

    if (this.originRoute === 'taskListDtag') {
      label = this.translateService.instant(
        'menu.tickets_tasks.component.dtag_tasks_view'
      );
      route = '/tasks_dtag';
    } else if (this.originRoute === 'tickets') {
      label = this.translateService.instant('taskmodule.tickets.list.title_dl');
      route = '/tickets';
    } else if (this.originRoute === 'tickets_dtag') {
      label = this.translateService.instant('taskmodule.tickets.list.title');
      route = '/tickets_dtag';
    }

    setTimeout(() => {
      this.breadcrumbService.setBreadcrumbs([
        {
          label,
          onClick: () => {
            this.router.navigateByUrl(route);
          },
        },
        {
          label: this.translateService.instant('taskmodule.task.update.title'),
        },
      ]);
    }, 0);

    this.route.queryParams.subscribe(params => {
      const tabIndex = params['tab'];

      if (tabIndex === 'contact') {
        this.activeTab = this.tabs[2].id;
      } else {
        this.activeTab = this.tabs[0].id;
      }
    });
    this.taskInformations = [
      {
        key: 'subject',
        type: 'input',
        wrappers: ['readOnly'],
        props: {
          label: this.translate('label__subject'),
          readOnly: true,
        },
      },
      {
        key: 'description',
        type: 'input',
        wrappers: ['readOnly'],
        props: {
          label: this.translate('label__taskDescription'),
          readOnly: true,
        },
      },
      {
        key: 'dueDate',
        type: 'input',
        wrappers: ['readOnly'],
        props: {
          label: this.translate('label__dueDate'),
          readOnly: true,
          valueFormatter: _dueDate => {
            return '--';
            // TODO Reimplement this if use of dueDate is determined https://dev.azure.com/pts-vsts/Magenta%20Squad/_workitems/edit/19247
            // if (!dueDate) {
            //   return '--';
            // }
            // const now = moment(new Date());
            // let r = moment(dueDate)
            //   .locale(this.translateService.instant('locale.locale'))
            //   .format(
            //     this.translateService.instant('locale.moment__date_format')
            //   );
            // r +=
            //   moment(dueDate).diff(now, 'days') < 0
            //     ? ` &nbsp;<span class="warning-tag"> ${this.translate(
            //         'info__overdue'
            //       )}
            //     <i class="material-icons">warning_amber</i> </span>
            //     `
            //     : '';
            // return r;
          },
        },
      },
      {
        wrappers: ['form-field', 'count-chars'],
        key: 'result',
        type: 'textarea',
        props: {
          label: this.translate('label__result'),
          visibleInConfirm: true,
          required: this.masterRequired,
          autosize: true,
          autosizeMinRows: 4,
          maxLength: 2000,
        },
      },
      {
        key: 'status',
        type: 'input',
        wrappers: ['readOnly'],
        props: {
          label: this.translate('label__actualStatus'),
          readOnly: true,
        },
        hooks: {
          onInit: field => {
            field?.formControl?.valueChanges.subscribe({
              next: value => {
                if (value === 'In Bearbeitung') {
                  const index = this.formFields.findIndex(
                    x => x.key === 'newStatus'
                  );
                  this.formFields[index].defaultValue =
                    TaskStatus.InBearbeitung;
                }
                if (this.task?.configurationTask?.fmConfigurationRow) {
                  const formGroup =
                    this.formFields[
                      this.formFields.findIndex(
                        x => x.key === this.updateIncidentFieldGroupName
                      )
                    ];
                  for (const row of this.task.configurationTask
                    .fmConfigurationRow) {
                    if (row.name) {
                      const key = this.firstLowercase(row.name);
                      if (formGroup?.fieldGroup) {
                        const formField =
                          formGroup.fieldGroup[
                            formGroup?.fieldGroup?.findIndex(x => x.key === key)
                          ];
                        if (formField?.props?.required !== undefined) {
                          formField.props.required =
                            value === 'Abgeschlossen' ||
                            value === 'Nicht gestartet';
                        }
                      }
                    }
                  }
                }
              },
            });
          },
        },
      },
      {
        type: 'select',
        key: 'cancelStatus',
        hide: true,
        props: {
          label: this.translate('label__cancelTicket'),
          required: this.masterRequired,
          options: this.optionSetClient
            .getOptionSetByString('affinis_decision')
            .pipe(
              map(sysEnums => {
                return sysEnums
                  .map((sysEnum: SysEnum) => {
                    delete sysEnum.sysEnumTranslation;
                    const s = { ...sysEnum };
                    return {
                      label:
                        this.ibpdiHelperService.getTranslatedEnumLable(sysEnum),
                      value: s,
                    };
                  })
                  .sort((a, b) => a.label.localeCompare(b.label));
              })
            ),
          compareWith(o1: any, o2: any) {
            return o1?.id === o2?.id;
          },
        },
      },
      {
        type: 'select',
        key: 'newStatus',
        props: {
          label: this.translate('label__newStatus'),
          required: this.masterRequired,
          options: this.getNewStatusOptions(),
          compareWith(o1: any, o2: any) {
            if (o1 === o2) {
              return true;
            }

            if (o1 == null || o2 == null) {
              return false;
            }

            const value1 = typeof o1 === 'object' ? (o1.id ?? o1.value) : o1;
            const value2 = typeof o2 === 'object' ? (o2.id ?? o2.value) : o2;

            return value1 === value2;
          },
        },
        expressions: {
          'props.options': () => this.getNewStatusOptions(),
        },
        hooks: {
          onInit: field => {
            field?.formControl?.valueChanges.subscribe({
              next: value => {
                if (this.task?.configurationTask?.fmConfigurationRow) {
                  const formGroup =
                    this.formFields[
                      this.formFields.findIndex(
                        x => x.key === this.updateIncidentFieldGroupName
                      )
                    ];
                  for (const row of this.task.configurationTask
                    .fmConfigurationRow) {
                    if (row.name) {
                      const key = this.firstLowercase(row.name);
                      if (formGroup?.fieldGroup) {
                        const formField =
                          formGroup.fieldGroup[
                            formGroup?.fieldGroup?.findIndex(x => x.key === key)
                          ];
                        if (formField?.props?.required !== undefined) {
                          formField.props.required =
                            value === TaskStatus.Abgeschlossen;
                        }
                      }
                    }
                  }
                }
              },
            });
          },
        },
      },
    ];
    this.formFields = [...this.incidentInformations, ...this.taskInformations];
  }

  modelOnChange() {
    const formChanged = this.hasRelevantFormChanges();
    const offerChanged = !isEqual(
      this.editedLocations,
      this.editedLocationsInit
    );
    const serviceRegistrationChanged = !isEqual(
      this.serviceRegistrationLocations,
      this.serviceRegistrationLocationsInit
    );

    const newStatus = this.formModel?.newStatus;
    const isAddendumStatusWithoutOffer =
      this.isTask7ExecuteOptionalService &&
      newStatus === TaskStatus.Nachtragsangebot &&
      this.editedLocations.length === 0;

    const isClosedStatusWithoutCompletedServiceRegistration =
      this.isTask7ExecuteOptionalService &&
      newStatus === TaskStatus.Abgeschlossen &&
      !this.isServiceRegistrationFullyCompleted();

    this.isSaveButtonEnabled =
      !isAddendumStatusWithoutOffer &&
      !isClosedStatusWithoutCompletedServiceRegistration &&
      (formChanged || offerChanged || serviceRegistrationChanged);

    this.updateNewStatusFieldOptions(this.formFields);
  }

  private hasRelevantFormChanges(): boolean {
    const currentModel = cloneDeep(this.formModel || {});
    const initialModel = cloneDeep(this.formModelInit || {});

    if (this.isTask7ExecuteOptionalService) {
      const currentStatus = currentModel?.newStatus;
      const initialStatus = initialModel?.newStatus;
      const currentIsClosed = currentStatus === TaskStatus.Abgeschlossen;
      const initialIsClosed = initialStatus === TaskStatus.Abgeschlossen;

      if (!currentIsClosed && !initialIsClosed) {
        const normalizeResult = (value: any) => {
          const normalized = String(value ?? '').trim();
          return normalized === '' ? undefined : normalized;
        };

        currentModel.result = normalizeResult(currentModel.result);
        initialModel.result = normalizeResult(initialModel.result);
      }
    }

    return !isEqual(currentModel, initialModel);
  }

  async getItem(id: string | null) {
    if (!id) {
      return;
    }
    this.isLoading = true;
    this.taskClient
      .getTask(id, false)
      .pipe(first())
      .subscribe({
        next: (
          data: ResultExtensionWrapperOfTaskViewModelAndIEnumerableOfIncidentFieldMapping
        ) => {
          this.isLoading = false;
          this.cd.detectChanges();

          if (!data) {
            this.showErrorToastLoadTask();
            this.cd.detectChanges();
            return;
          }

          this.entity = data;
          this.task = data.entity;
          this.dataContactAddress = data.entity.incident;
          this.extension = data.extension;

          this.isTask2EvaluateOffersAndCreateSuppliers =
            this.task?.subject ===
            TaskSubject.OPL_EXT_EVALUATE_OFFERS_AND_CREATE_SUPPLIERS;

          this.isTask3EvaluateOfferInquiry =
            this.task?.subject === TaskSubject.OPL_EXT_EVALUATE_OFFER_INQUIRY;

          this.isTask7ExecuteOptionalService =
            this.task?.subject === TaskSubject.OPL_EXT_EXECUTE_OPTIONAL_SERVICE;

          this.isTask11SubmitInvoiceToScanCenter =
            this.task?.subject ===
            TaskSubject.OPL_EXT_SUBMIT_INVOICE_TO_SCAN_CENTER;

          this.updateNewStatusFieldOptions(this.taskOPLExtInformations);
          this.updateNewStatusFieldOptions(this.taskInformations);

          if (
            data.entity?.incident?.incidentClass?.incidentClass ===
            IncidentClass.OptionalServicesExternal
          ) {
            this.isOPLExt = true;
          }

          this.formFields = this.isOPLExt
            ? [...this.incidentOPLExtInformations]
            : [...this.incidentInformations, ...this.taskInformations];

          this.updateNewStatusFieldOptions(this.formFields);

          if (this.isOPLExt === false) {
            this.fillIncidentAttributeForm();
          }

          const fileMetadata = [
            {
              attributeName: 'incidentId',
              attributeValue: data.entity?.incidentId || 'error no incidentId',
            },
            {
              attributeName: 'taskId',
              attributeValue: data.entity?.taskId || 'error no taskId',
            },
            {
              attributeName: 'visibilityId',
              attributeValue: DocumentVisibility.InternAndContractors,
            },
            {
              attributeName: 'defaultDocumentTypeId',
              attributeValue: data.entity?.configurationTask
                ? // eslint-disable-next-line @typescript-eslint/dot-notation
                  (data.entity?.configurationTask['defaultDocumentTypeId'] ??
                  '')
                : '',
            },
          ];

          this.detailFields.forEach((detailField: IDetailFields) => {
            detailField.fileMetadata = fileMetadata;
          });

          if (this.isOPLExt === true) {
            const frameworkContractId =
              this.task?.incident?.fmServiceRequestExternal
                ?.frameworkContractId;
            let quotationValidUntil: Date | null = null;

            this.isDummyFrameworkContract = frameworkContractId?.startsWith(
              'frameworkContract-1000'
            );

            // Aufgabe 3: Angebot bewerten (OPL_EXT_EVALUATE_OFFER_INQUIRY)
            if (this.isTask3EvaluateOfferInquiry) {
              this.tooltipSelectDocument = this.translateService.instant(
                'ticket.create.p__info_attachment_preselected'
              );

              this.tooltipUploadDocument = this.translateService.instant(
                'taskmodule.task.documents.tooltip.upload_document_for_offer_inquiry'
              );

              const allRequests = this.task?.incident?.fmQuotationRequest || [];
              const hasMultipleRequests = allRequests.length > 1;

              // Sortieren nach Datum (neuestes zuerst)
              const sortedRequests = [...allRequests].sort(
                (a, b) =>
                  new Date(b.changeDate || 0).getTime() -
                  new Date(a.changeDate || 0).getTime()
              );

              const latestRequest = sortedRequests[0];

              this.locations = (
                latestRequest?.fmQuotationRequestLine || []
              ).sort((a, b) => (a.recordNumber || 0) - (b.recordNumber || 0));

              const hasLocations = this.locations.length > 0;
              this.formFields.push({
                fieldGroupClassName: 'button-row-container',
                fieldGroup: [
                  {
                    type: 'button',
                    hideExpression: () => !hasMultipleRequests,
                    props: {
                      label: this.translateService.instant(
                        'taskmodule.task.offer.view_previous_offers'
                      ),
                      tooltip: this.translateService.instant(
                        'taskmodule.task.offer.tooltip.view_previous_offers'
                      ),
                      color: 'primary',
                      onClick: () => this.showHistory(),
                      disabled: !hasLocations,
                    },
                  },
                  {
                    type: 'button',
                    props: {
                      label: hasMultipleRequests
                        ? this.translateService.instant(
                            'taskmodule.task.offer.dialog_title_new'
                          )
                        : this.translateService.instant(
                            'taskmodule.task.offer.dialog_title'
                          ),
                      tooltip: hasMultipleRequests
                        ? this.translateService.instant(
                            'taskmodule.task.offer.tooltip.submit_new_offer'
                          )
                        : this.translateService.instant(
                            'taskmodule.task.offer.tooltip.submit_offer'
                          ),
                      color: 'primary',
                      onClick: () => this.onSubmitOffer(),
                      disabled: !hasLocations,
                    },
                  },
                ],
              });

              this.cd.detectChanges();

              const hasAnyComment = (this.locations as any[]).some(
                l => !!String(l?.comment ?? '').trim()
              );

              const baseColumns = this.isDummyFrameworkContract
                ? this.getServiceLineColumnsForDummyOfferInquiry(true)
                : this.serviceLineColumns.filter(
                    col => col.field !== 'serviceProviderComment'
                  );

              const columnsToUse = hasAnyComment
                ? (() => {
                    const cols = [...baseColumns];
                    const totalPriceIdx = cols.findIndex(
                      c => c.field === 'totalPrice'
                    );
                    const commentColumn = {
                      header:
                        this.translateService.instant(
                          'taskmodule.shared.label__comment'
                        ) || 'Kommentar',
                      field: 'comment',
                      sortable: false,
                    };
                    if (totalPriceIdx > -1) {
                      cols.splice(totalPriceIdx + 1, 0, commentColumn as any);
                    } else {
                      cols.push(commentColumn as any);
                    }
                    return cols;
                  })()
                : baseColumns;

              this.formFields.push({
                key: 'locationsExpandable',
                type: 'locations-expandable',
                props: {
                  headline:
                    this.translateService.instant(
                      'taskmodule.task.offer.locations_offer'
                    ) || 'Standorte',
                  headlineTooltip: this.translateService.instant(
                    'taskmodule.task.offer.tooltip.locations.base'
                  ),
                  locations: this.locations,
                  serviceLineColumns: columnsToUse,
                  fmIncidentArchObj:
                    this.task?.incident?.fmIncidentArchObj || [],
                  isDummyFrameworkContract: this.isDummyFrameworkContract,
                  respectPriceNegotiatedForDummy: this.isDummyFrameworkContract,
                  isOfferPosition: false,
                  equipmentByArchObjId:
                    this.equipmentService.buildEquipmentByArchObjId(this.task),
                  equipmentColumns: this.equipmentService.buildEquipmentColumns(
                    {
                      includeDocumentation: false,
                    }
                  ),
                  equipmentFilterDate: latestRequest?.changeDate
                    ? new Date(latestRequest.changeDate)
                    : undefined,
                  disableEquipmentDocumentationUpload: true,
                },
              });

              // If Quotation with QuotationLines exists, show them as offer positions
              const latestQuotation = latestRequest?.fmQuotation?.[0];
              quotationValidUntil = latestQuotation?.validUntil
                ? new Date(latestQuotation.validUntil)
                : null;
              if (
                latestQuotation?.fmQuotationLine &&
                latestQuotation.fmQuotationLine.length > 0
              ) {
                const requestLines =
                  (latestRequest?.fmQuotationRequestLine as any[]) || [];
                // Sort QuotationLines by recordNumber
                this.editedLocations = latestQuotation.fmQuotationLine
                  .map(line => {
                    const matchingRequestLine = requestLines.find(
                      (requestLine: any) =>
                        requestLine.id === line.quotationRequestLineId ||
                        (requestLine.recordNumber === line.recordNumber &&
                          requestLine.archObjId === line.archObjId)
                    );

                    return {
                      ...line,
                      priceNegotiated:
                        (line as any).priceNegotiated ??
                        (matchingRequestLine as any)?.priceNegotiated ??
                        false,
                    };
                  })
                  .sort(
                    (a, b) => (a.recordNumber || 0) - (b.recordNumber || 0)
                  );
                this.showEditedLocations = true;

                this.formFields.push({
                  key: 'editedLocationsExpandable',
                  type: 'locations-expandable',
                  props: {
                    headline: this.translateService.instant(
                      'taskmodule.task.offer.locations_offer_positions'
                    ),
                    // headlineTooltip: this.translateService.instant(
                    //   'taskmodule.task.offer.tooltip.locations'
                    // ),
                    locations: this.editedLocations,
                    serviceLineColumns: this.serviceLineColumns,
                    fmIncidentArchObj:
                      this.task?.incident?.fmIncidentArchObj || [],
                    isDummyFrameworkContract: this.isDummyFrameworkContract,
                    totalSumLabel: this.translateService.instant(
                      'taskmodule.task.offer.total_offer_positions_label'
                    ),
                    isOfferPosition: true,
                    equipmentByArchObjId:
                      this.equipmentService.buildEquipmentByArchObjId(
                        this.task
                      ),
                    equipmentColumns:
                      this.equipmentService.buildEquipmentColumns({
                        includeDocumentation: false,
                      }),
                    disableEquipmentDocumentationUpload: true,
                  },
                });
              }

              this.formFields.push(...this.taskOPLExtInformations);

              this.tabs.push({
                label: this.translateService.instant(
                  'taskmodule.shared.label__contact_us'
                ),
                id: 'contactUs',
                onClick: (id: string) => this.onTabClick(id),
              });
            }

            if (this.isTask2EvaluateOffersAndCreateSuppliers) {
              this.isTask2LineItemsEditable = false;

              this.locations = (
                this.task?.incident?.fmIncidentServiceLine || []
              ).sort((a, b) => (a.recordNumber || 0) - (b.recordNumber || 0));

              this.editedLocations = this.locations.map(location => ({
                ...location,
                priceNegotiated: (location as any).priceNegotiated ?? false,
              }));

              const serviceLineColumnsWithPriceNegotiated = [
                ...this.serviceLineColumns,
              ];
              const totalPriceIndex =
                serviceLineColumnsWithPriceNegotiated.findIndex(
                  col => col.field === 'totalPrice'
                );
              const priceNegotiatedColumn = {
                header: this.translateService.instant(
                  'taskmodule.task.offer.negotiated_price'
                ),
                field: 'priceNegotiated',
                sortable: false,
                width: '140px',
              };

              if (totalPriceIndex !== -1) {
                serviceLineColumnsWithPriceNegotiated.splice(
                  totalPriceIndex + 1,
                  0,
                  priceNegotiatedColumn as any
                );
              } else {
                serviceLineColumnsWithPriceNegotiated.push(
                  priceNegotiatedColumn as any
                );
              }

              const locationsFieldProps = {
                headline:
                  this.translateService.instant(
                    'taskmodule.shared.label__locations'
                  ) || 'Standorte',
                headlineTooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.locations.base'
                ),
                locations: this.editedLocations,
                serviceLineColumns: serviceLineColumnsWithPriceNegotiated,
                fmIncidentArchObj: this.task?.incident?.fmIncidentArchObj || [],
                units: [] as any[],
                hideComment: true,
                readOnlyUnit: true,
                enableManualLineManagement: true,
                readOnlyMode: !this.isTask2LineItemsEditable,
                expandAllPanels: false,
                onChange: () => {
                  this.modelOnChange();
                },
                equipmentByArchObjId:
                  this.equipmentService.buildEquipmentByArchObjId(this.task),
                equipmentColumns: this.equipmentService.buildEquipmentColumns({
                  includeDocumentation: false,
                }),
                hideEquipmentWithDeleteDate: true,
                disableEquipmentDocumentationUpload: true,
                taskId: this.task?.taskId,
                incidentId: this.task?.incidentId,
                onEquipmentDocumentationUploadStateChange: (
                  isUploading: boolean
                ) => this.setEquipmentDocumentationUploadState(isUploading),
                onEquipmentDocumentationUploaded: (uploadResult: any) =>
                  this.handleEquipmentDocumentationUploaded(uploadResult),
              };

              this.unitClient.getUnits().subscribe(result => {
                const units = result.filter(
                  (unit: FmUnit) => unit.isPrimary === true
                );
                locationsFieldProps.units = units;
                this.units = units;
                this.cd.detectChanges();
              });

              const locationsField = {
                key: 'locationsTask2',
                type: 'locations-expandable-editable',
                props: locationsFieldProps,
              };

              this.formFields = this.formFields.map(card => ({
                ...card,
                fieldGroup: card.fieldGroup?.map(group => {
                  const fields = group.fieldGroup || [];
                  const purchasingInfoIndex = fields.findIndex(
                    f =>
                      f.key ===
                      'incident.fmServiceRequestExternal.purchasingInformation'
                  );
                  if (purchasingInfoIndex !== -1) {
                    const newFields = [...fields];
                    newFields.splice(
                      purchasingInfoIndex + 1,
                      0,
                      locationsField
                    );
                    return { ...group, fieldGroup: newFields };
                  }
                  return group;
                }),
              }));

              this.formFields.push(...this.taskOPLExtInformations);

              this.tabs.push({
                label: this.translateService.instant(
                  'taskmodule.shared.label__contact_us'
                ),
                id: 'contactUs',
                onClick: (id: string) => this.onTabClick(id),
              });
            }

            if (
              this.isTask7ExecuteOptionalService ||
              this.isTask11SubmitInvoiceToScanCenter
            ) {
              this.tooltipSelectDocument = this.translateService.instant(
                this.isTask7ExecuteOptionalService
                  ? 'ticket.create.p__info_attachment_preselected'
                  : 'taskmodule.task.documents.tooltip.select_document_for_execute_optional_service'
              );

              this.tooltipUploadDocument = this.translateService.instant(
                'taskmodule.task.documents.tooltip.upload_document_for_execute_optional_service'
              );

              const allPurchaseOrders =
                this.task?.incident?.fmPurchaseOrder || [];

              const sortedPurchaseOrders = [...allPurchaseOrders].sort(
                (a, b) =>
                  new Date(
                    b.orderDate || (b as any).changeDate || 0
                  ).getTime() -
                  new Date(a.orderDate || (a as any).changeDate || 0).getTime()
              );

              const purchaseOrdersWithDisplayLines =
                sortedPurchaseOrders.filter(
                  purchaseOrder =>
                    this.getQuotationLinesFromPurchaseOrder(purchaseOrder)
                      .length > 0
                );

              const documentsByQuotationLineId =
                getServiceRegistrationDocumentsByQuotationLineId(
                  this.task,
                  this.task?.configurationTask?.defaultDocumentTypeId
                );

              const purchaseOrderQuotationLines = purchaseOrdersWithDisplayLines
                .flatMap(purchaseOrder =>
                  this.getQuotationLinesFromPurchaseOrder(purchaseOrder).map(
                    line => ({
                      ...line,
                      purchaseOrder,
                      archObj:
                        line.archObj ||
                        this.task?.incident?.fmIncidentServiceLine?.find(
                          (sl: any) => sl.archObjId === line.archObjId
                        )?.archObj,
                      orderNumber: purchaseOrder?.orderNumber,
                      serviceRegistrationCompletionDate:
                        (line as any).serviceRegistrationCompletionDate ||
                        purchaseOrder?.completionDate ||
                        null,
                      serviceRegistrationDocumentationFiles:
                        documentsByQuotationLineId.get(line?.id || '') || [],
                      quotationId:
                        (line as any).quotationId || purchaseOrder?.quotationId,
                      quotationLineId: line.id,
                    })
                  )
                )
                .sort((a, b) => (a.recordNumber || 0) - (b.recordNumber || 0));

              this.locations = purchaseOrderQuotationLines;
              this.serviceRegistrationLocations =
                prepareServiceRegistrationLocations(
                  purchaseOrderQuotationLines,
                  {
                    includePurchaseOrderCompletionDateFallback: true,
                  }
                );

              const latestAddendumLines =
                this.getLatestAddendumQuotationLines();
              if (latestAddendumLines.length > 0) {
                this.editedLocations = latestAddendumLines;
                this.showEditedLocations = true;
              }

              const purchaseOrderNumber =
                purchaseOrdersWithDisplayLines
                  .map(purchaseOrder => purchaseOrder?.orderNumber)
                  .filter((orderNumber): orderNumber is string => !!orderNumber)
                  .filter(
                    (orderNumber, index, orderNumbers) =>
                      orderNumbers.indexOf(orderNumber) === index
                  )
                  .join(', ') || '-';

              this.formFields.push({
                fieldGroupClassName: 'button-row-container',
                hide: this.isTask11SubmitInvoiceToScanCenter,
                fieldGroup: [
                  {
                    key: 'submitAddendumOfferButton',
                    type: 'button',
                    props: {
                      label: this.translateService.instant(
                        'taskmodule.task.offer.addendum_offer'
                      ),
                      tooltip: this.translateService.instant(
                        'taskmodule.task.offer.tooltip.addendum_offer'
                      ),
                      color: 'primary',
                      onClick: () => this.onSubmitAddendumOffer(),
                      disabled: this.hasExistingAddendumOffer,
                    },
                  },
                  {
                    type: 'button',
                    props: {
                      label: this.translateService.instant(
                        'taskmodule.task.service_registration.label_button'
                      ),
                      tooltip: this.translateService.instant(
                        'taskmodule.task.offer.tooltip.service_registration_button'
                      ),
                      color: 'primary',
                      onClick: () => this.addServiceRegistrationFields(),
                    },
                  },
                ],
              });

              // Infozeile für Aufgabe 11
              this.formFields.push({
                key: 'formly-notification',
                type: 'formly-notification',
                hide: !this.isTask11SubmitInvoiceToScanCenter,
                props: {
                  heading: this.translateService.instant(
                    'taskmodule.task.offer.notification_task_11'
                  ),
                },
              });

              this.cd.detectChanges();

              const columnsToUse = this.serviceLineColumns
                .filter(col => col.field !== 'serviceProviderComment')
                .map(col => {
                  if (col.field === 'quantity') {
                    return {
                      ...col,
                      header: this.translateService.instant(
                        this.isTask11SubmitInvoiceToScanCenter
                          ? 'taskmodule.task.offer.quantity_service_receipt'
                          : 'taskmodule.task.offer.order_quantity'
                      ),
                      field: this.isTask11SubmitInvoiceToScanCenter
                        ? 'quantityProvided'
                        : 'quantity',
                      formatter: (row: any) =>
                        this.isTask11SubmitInvoiceToScanCenter
                          ? (row?.quantityProvided ?? 0)
                          : (row?.quantity ?? 0),
                    };
                  }

                  if (col.field === 'totalPrice') {
                    return {
                      ...col,
                      header: this.translateService.instant(
                        this.isTask11SubmitInvoiceToScanCenter
                          ? 'taskmodule.task.offer.invoice_value'
                          : 'taskmodule.task.offer.order_price'
                      ),
                      formatter: (row: any) => {
                        if (
                          this.isTask11SubmitInvoiceToScanCenter &&
                          row?.purchaseOrder?.serviceAcceptanceCompleted !==
                            true
                        ) {
                          return '-';
                        }

                        const quantity = this.isTask11SubmitInvoiceToScanCenter
                          ? parseFloat(String(row?.quantityProvided)) || 0
                          : parseFloat(String(row?.quantity)) || 0;
                        const unitPrice =
                          parseFloat(String(row?.unitPrice)) || 0;
                        return `${formatPrice(quantity * unitPrice)} €`;
                      },
                    };
                  }

                  return col;
                });

              this.formFields.push({
                key: 'locationsExpandable',
                type: 'locations-expandable',
                props: {
                  headline:
                    this.translateService.instant(
                      this.isTask11SubmitInvoiceToScanCenter
                        ? 'taskmodule.task.offer.locations_billable_positions_order'
                        : 'taskmodule.task.offer.locations_offer_positions_order'
                    ) || 'Standorte',
                  headlineTooltip: this.translateService.instant(
                    this.isTask11SubmitInvoiceToScanCenter
                      ? 'taskmodule.task.offer.tooltip.locations.billable_positions'
                      : 'taskmodule.task.offer.tooltip.locations.offer_positions_order'
                  ),
                  locations: this.locations,
                  serviceLineColumns: columnsToUse,
                  fmIncidentArchObj:
                    this.task?.incident?.fmIncidentArchObj || [],
                  orderNumber: purchaseOrderNumber,
                  locationSumLabel: this.translateService.instant(
                    this.isTask11SubmitInvoiceToScanCenter
                      ? 'taskmodule.task.offer.invoice_value_location'
                      : 'taskmodule.task.offer.order_price_location'
                  ),
                  totalSumLabel: this.translateService.instant(
                    this.isTask11SubmitInvoiceToScanCenter
                      ? 'taskmodule.task.offer.invoice_value_total'
                      : 'taskmodule.task.offer.order_sum_total'
                  ),
                  isDummyFrameworkContract: this.isDummyFrameworkContract,
                  usePurchaseOrderLineNetPrice: false,
                  isOfferPosition: false,
                  equipmentByArchObjId:
                    this.equipmentService.buildEquipmentByArchObjId(this.task),
                  equipmentColumns: this.equipmentService.buildEquipmentColumns(
                    {
                      includeDocumentation: this.isTask7ExecuteOptionalService
                        ? this.isServiceRegistrationModeActive
                        : !this.isTask11SubmitInvoiceToScanCenter,
                    }
                  ),
                  equipmentFilterDate: (() => {
                    const quotations = purchaseOrdersWithDisplayLines
                      .map(po => this.getQuotationForPurchaseOrder(po))
                      .filter((q): q is any => !!q);
                    const sorted = [...quotations].sort(
                      (a, b) =>
                        new Date(b.changeDate || 0).getTime() -
                        new Date(a.changeDate || 0).getTime()
                    );
                    return sorted[0]?.changeDate
                      ? new Date(sorted[0].changeDate)
                      : undefined;
                  })(),
                  sumOnlyServiceAcceptanceCompleted:
                    this.isTask11SubmitInvoiceToScanCenter,
                  orderSumQuantityField: this.isTask11SubmitInvoiceToScanCenter
                    ? 'quantityProvided'
                    : 'quantity',
                  documentUploadConfigurationTaskId:
                    this.task?.configurationTaskId || null,
                  defaultDocumentTypeName:
                    this.defaultEquipmentDocumentTypeName,
                  tooltipSelectDocument: this.tooltipSelectDocument,
                  tooltipUploadDocument: this.tooltipUploadDocument,
                  allowedFileExtensions: this.task3And7AllowedFileExtensions,
                  maxUploadFiles: 10,
                  taskId: this.task?.taskId,
                  incidentId: this.task?.incidentId,
                  incidentClassName:
                    this.task?.incident?.incidentClass?.incidentClass || '',
                  incidentClassId:
                    this.task?.incident?.incidentClass?.incidentClassId || '',
                  disableEquipmentDocumentationUpload: this
                    .isTask7ExecuteOptionalService
                    ? !this.isServiceRegistrationModeActive
                    : this.isTask11SubmitInvoiceToScanCenter,
                  onChange: () => this.modelOnChange(),
                  onEquipmentDocumentationUploadStateChange: (
                    isUploading: boolean
                  ) => this.setEquipmentDocumentationUploadState(isUploading),
                  onEquipmentDocumentationUploaded: (uploadResult: any) =>
                    this.handleEquipmentDocumentationUploaded(uploadResult),
                },
              });

              if (this.showEditedLocations && this.editedLocations.length > 0) {
                this.formFields.push({
                  key: 'editedLocationsExpandable',
                  type: 'locations-expandable',
                  props: {
                    headline: this.translateService.instant(
                      this.isTask11SubmitInvoiceToScanCenter
                        ? 'taskmodule.task.offer.locations_billable_addendum_positions'
                        : 'taskmodule.task.offer.locations_addendum_positions'
                    ),
                    headlineTooltip: this.translateService.instant(
                      this.isTask11SubmitInvoiceToScanCenter
                        ? 'taskmodule.task.offer.tooltip.locations.billable_addendum_positions'
                        : 'taskmodule.task.offer.tooltip.locations.addendum_positions'
                    ),
                    locations: this.getAddendumLocationsForDisplay(
                      this.editedLocations
                    ),
                    serviceLineColumns: this.isTask11SubmitInvoiceToScanCenter
                      ? this.serviceLineColumns.map(col => {
                          if (col.field === 'quantity') {
                            return {
                              ...col,
                              header: this.translateService.instant(
                                'taskmodule.task.offer.quantity_service_receipt'
                              ),
                              field: 'quantityProvided',
                              formatter: (row: any) =>
                                row?.quantityProvided ?? 0,
                            };
                          }

                          if (col.field !== 'totalPrice') {
                            return col;
                          }

                          return {
                            ...col,
                            header: this.translateService.instant(
                              'taskmodule.task.offer.invoice_value'
                            ),
                            formatter: (row: any) => {
                              if (
                                row?.purchaseOrder
                                  ?.serviceAcceptanceCompleted !== true
                              ) {
                                return '-';
                              }

                              const quantity =
                                parseFloat(String(row?.quantityProvided)) || 0;
                              const unitPrice =
                                parseFloat(String(row?.unitPrice)) || 0;
                              return `${formatPrice(quantity * unitPrice)} €`;
                            },
                          };
                        })
                      : this.serviceLineColumns,
                    fmIncidentArchObj:
                      this.task?.incident?.fmIncidentArchObj || [],
                    isDummyFrameworkContract: this.isDummyFrameworkContract,
                    locationSumLabel: this.translateService.instant(
                      this.isTask11SubmitInvoiceToScanCenter
                        ? 'taskmodule.task.offer.invoice_value_addendum_location'
                        : 'taskmodule.task.offer.total_location_label'
                    ),
                    totalSumLabel: this.translateService.instant(
                      this.isTask11SubmitInvoiceToScanCenter
                        ? 'taskmodule.task.offer.invoice_value_addendum_total'
                        : 'taskmodule.task.offer.total_addendum_positions_label'
                    ),
                    isOfferPosition: true,
                    sumOnlyServiceAcceptanceCompleted:
                      this.isTask11SubmitInvoiceToScanCenter,
                    orderSumQuantityField: this
                      .isTask11SubmitInvoiceToScanCenter
                      ? 'quantityProvided'
                      : 'quantity',
                    showAddendumStatusReason: true,
                    showAddendumCommentDisplay: true,
                    addendumStatusReason: this.getLatestAddendumStatusReason(),
                    addendumComment:
                      this.getLatestAddendumQuotation()
                        ?.serviceProviderComment || '',
                    addendumInternalComment:
                      this.getLatestAddendumQuotation()?.internalComment || '',
                  },
                });
              }

              this.formFields.push(...this.taskOPLExtInformations);

              this.tabs.push({
                label: this.translateService.instant(
                  'taskmodule.shared.label__contact_us'
                ),
                id: 'contactUs',
                onClick: (id: string) => this.onTabClick(id),
              });

              this.syncAddendumUiState();
            }

            // Extract serviceProvider if it exists and add to organisationMap
            const serviceProvider =
              data.entity?.incident?.fmServiceRequestExternal?.serviceProvider;

            if (serviceProvider?.organisationId && serviceProvider?.name) {
              this.organisationMap.set(
                serviceProvider.organisationId,
                serviceProvider.name
              );
            }

            this.formModel = {
              ...this.formModel,
              ...data.entity,
              newStatus: TaskStatus.InBearbeitung,
              validUntil: quotationValidUntil,
              serviceProviderSelection:
                serviceProvider?.organisationId && serviceProvider?.name
                  ? {
                      searchResult: {
                        id: serviceProvider.organisationId,
                        name: serviceProvider.name,
                      },
                    }
                  : null,
              serviceProviderCommentAddendum:
                this.getLatestAddendumQuotation()?.serviceProviderComment || '',
            };

            this.cd.detectChanges();

            this.getSubIncidents();

            this.formModelInit = cloneDeep(this.formModel);
            this.editedLocationsInit = cloneDeep(this.editedLocations);
            this.serviceRegistrationLocationsInit = cloneDeep(
              this.serviceRegistrationLocations
            );
          } else {
            this.formModel = {
              ...this.formModel,
              ...data.entity,
            };

            this.cd.detectChanges();

            if (
              this.task?.incident?.incidentClass?.incidentClass ===
                IncidentClass.Relocation &&
              this.task?.incident?.requestType === 'Kundenprozesse' &&
              this.task?.subject === '7. Ticketabschluss'
            ) {
              const index = this.taskInformations.findIndex(
                x => x.key === 'cancelStatus'
              );
              this.taskInformations[index].hide = false;
            }

            this.getSubIncidents();

            this.formModelInit = cloneDeep(this.formModel);
          }
        },
        error: error => {
          this.isLoading = false;
          this.showErrorToastLoadTask();
          this.cd.detectChanges();
          console.log(error);
        },
      });
  }

  private hasPendingServiceRegistrationChanges(): boolean {
    return (
      this.isTask7ExecuteOptionalService &&
      this.isServiceRegistrationModeActive &&
      !isEqual(
        this.serviceRegistrationLocations,
        this.serviceRegistrationLocationsInit
      )
    );
  }

  private runSaveActionWithOptionalServiceRegistration(
    saveAction: () => void
  ): void {
    if (!this.validateCompletionDateForFullyCompletedServiceLocations()) {
      return;
    }

    if (!this.validateTask11PurchaseOrderServiceAcceptanceForCompletion()) {
      return;
    }

    if (!this.hasPendingServiceRegistrationChanges()) {
      saveAction();
      return;
    }

    void this.executeServiceRegistrationRequests({
      keepLoadingState: true,
      showSuccessToast: false,
    })
      .then(() => {
        saveAction();
      })
      .catch(err => {
        console.error(err);
        this.isLoading = false;
        this.showErrorToastUpdateTask();
        this.cd.detectChanges();
      });
  }

  private async executeServiceRegistrationRequests(options?: {
    keepLoadingState?: boolean;
    showSuccessToast?: boolean;
    includedQuotationLineIds?: Set<string>;
  }): Promise<boolean> {
    const {
      keepLoadingState = false,
      showSuccessToast = true,
      includedQuotationLineIds,
    } = options || {};
    const serviceRegistrationRequests =
      await this.buildServiceRegistrationRequests(includedQuotationLineIds);

    if (serviceRegistrationRequests.length === 0) {
      this.serviceRegistrationLocationsInit = cloneDeep(
        this.serviceRegistrationLocations
      );
      this.modelOnChange();
      this.cd.detectChanges();
      return false;
    }

    return new Promise((resolve, reject) => {
      const executeServiceRegistration = (requestIndex: number) => {
        if (requestIndex >= serviceRegistrationRequests.length) {
          this.applyServiceRegistrationCompletionDatesToLocalState(
            serviceRegistrationRequests
          );
          this.serviceRegistrationLocationsInit = cloneDeep(
            this.serviceRegistrationLocations
          );
          this.modelOnChange();

          if (showSuccessToast) {
            this.toastr.success(
              this.translateService.instant(
                'Die Leistungserfassung wurde erfolgreich übermittelt.'
              )
            );
          }

          if (!keepLoadingState) {
            this.isLoading = false;
          }

          this.cd.detectChanges();
          resolve(true);
          return;
        }

        this.isLoading = true;
        this.serviceRegistrationClient
          .updateServiceRegistration(serviceRegistrationRequests[requestIndex])
          .subscribe({
            next: () => {
              executeServiceRegistration(requestIndex + 1);
            },
            error: err => {
              reject(err);
            },
          });
      };

      executeServiceRegistration(0);
    });
  }

  private setEquipmentDocumentationUploadState(isUploading: boolean): void {
    this.isEquipmentDocumentationUploading = isUploading;
    this.cd.detectChanges();
  }

  async updateServiceRegistration(group?: { rows?: any[] }) {
    if (!this.validateCompletionDateForFullyCompletedServiceLocations(group)) {
      return;
    }

    const completionSummaryBeforeSubmit =
      this.getServiceRegistrationCompletionSummary();

    const includedQuotationLineIds = new Set<string>(
      (group?.rows || [])
        .map(
          row =>
            (row?.quotationLineId || row?.id || row?.quotationRequestLineId) as
              | string
              | undefined
        )
        .filter((id): id is string => !!id)
    );

    try {
      const serviceRegistrationWasSubmitted =
        await this.executeServiceRegistrationRequests({
          showSuccessToast: false,
          includedQuotationLineIds:
            includedQuotationLineIds.size > 0
              ? includedQuotationLineIds
              : undefined,
        });

      if (!serviceRegistrationWasSubmitted) {
        return;
      }

      this.markSubmittedServiceRegistrationRowsAsPersisted(
        includedQuotationLineIds.size > 0 ? includedQuotationLineIds : undefined
      );

      this.serviceRegistrationLocationsInit = cloneDeep(
        this.serviceRegistrationLocations
      );

      const taskAutoClosed =
        await this.tryAutoCloseTaskAfterLastServiceRegistration(
          completionSummaryBeforeSubmit
        );

      if (!taskAutoClosed) {
        this.toastr.success(
          this.translateService.instant(
            'Die Leistungserfassung wurde erfolgreich übermittelt.'
          )
        );
      }
    } catch (err) {
      this.isLoading = false;
      this.showErrorToastUpdateTask();
      this.cd.detectChanges();
    }
  }

  showHistory() {
    if (!this.task?.incident?.fmQuotationRequest) {
      return;
    }

    if (this.isPreviousOffersDialogOpening || this.previousOffersDialogRef) {
      return;
    }

    const columnsToUse = this.isDummyFrameworkContract
      ? this.getServiceLineColumnsForDummyOfferInquiry()
      : this.serviceLineColumns;

    // Sort by changeDate and filter out the most recent quotation request (current) to show only history
    const sortedQuotationRequests = [
      ...this.task.incident.fmQuotationRequest,
    ].sort(
      (a, b) =>
        new Date(b.changeDate || 0).getTime() -
        new Date(a.changeDate || 0).getTime()
    );

    const historyQuotationRequests = sortedQuotationRequests.slice(1);

    this.isPreviousOffersDialogOpening = true;
    this.enrichArchObjDataBeforeDialog(historyQuotationRequests, null)
      .pipe(finalize(() => (this.isPreviousOffersDialogOpening = false)))
      .subscribe(() => {
        this.openPreviousOffersDialog({
          title: this.translateService.instant(
            'taskmodule.task.offer.previous_offers_title'
          ),
          noEntriesMessage: this.translateService.instant(
            'taskmodule.task.offer.no_offers'
          ),
          quotationRequests: historyQuotationRequests,
          serviceLineColumns: columnsToUse,
          fmIncidentArchObj: this.task.incident.fmIncidentArchObj || [],
          isDummyFrameworkContract: this.isDummyFrameworkContract,
          equipmentByArchObjId: this.equipmentService.buildEquipmentByArchObjId(
            this.task
          ),
          equipmentColumns: this.equipmentService.buildEquipmentColumns({
            includeDocumentation: false,
          }),
        });
      });
  }

  showOrderedQuotation() {
    if (!this.task?.incident?.fmQuotation) {
      return;
    }

    if (this.isPreviousOffersDialogOpening || this.previousOffersDialogRef) {
      return;
    }

    const columnsToUse = this.isDummyFrameworkContract
      ? this.getServiceLineColumnsForDummyOfferInquiry()
      : this.serviceLineColumns;

    const latestMainQuotation = [...(this.task?.incident?.fmQuotation || [])]
      .filter(
        (quotation: FmQuotation) =>
          quotation.type?.defaultName === QuotationTypes.Offer ||
          quotation.type?.defaultName === undefined ||
          quotation.type?.defaultName === null
      )
      .sort(
        (a, b) =>
          new Date(b.changeDate || 0).getTime() -
          new Date(a.changeDate || 0).getTime()
      )[0];

    this.isPreviousOffersDialogOpening = true;
    this.enrichArchObjDataBeforeDialog(
      null,
      latestMainQuotation ? [latestMainQuotation] : []
    )
      .pipe(finalize(() => (this.isPreviousOffersDialogOpening = false)))
      .subscribe(() => {
        this.openPreviousOffersDialog({
          title: this.translateService.instant(
            'taskmodule.task.offer.ordered_offer.dialog_title'
          ),
          noEntriesMessage: this.translateService.instant(
            'taskmodule.task.offer.ordered_offer.no_entry'
          ),
          quotations: latestMainQuotation ? [latestMainQuotation] : [],
          serviceLineColumns: columnsToUse,
          fmIncidentArchObj: this.task.incident.fmIncidentArchObj || [],
          isDummyFrameworkContract: this.isDummyFrameworkContract,
          equipmentByArchObjId: this.equipmentService.buildEquipmentByArchObjId(
            this.task
          ),
          equipmentColumns: this.equipmentService.buildEquipmentColumns({
            includeDocumentation: false,
          }),
        });
      });
  }

  showOrderedAddendumQuotation() {
    if (!this.task?.incident?.fmQuotation) {
      return;
    }

    if (this.isPreviousOffersDialogOpening || this.previousOffersDialogRef) {
      return;
    }

    const columnsToUse = this.isDummyFrameworkContract
      ? this.getServiceLineColumnsForDummyOfferInquiry()
      : this.serviceLineColumns;

    const latestAcceptedAddendumQuotation =
      this.getLatestAcceptedAddendumQuotation();

    this.isPreviousOffersDialogOpening = true;
    this.enrichArchObjDataBeforeDialog(
      null,
      latestAcceptedAddendumQuotation ? [latestAcceptedAddendumQuotation] : []
    )
      .pipe(finalize(() => (this.isPreviousOffersDialogOpening = false)))
      .subscribe(() => {
        this.openPreviousOffersDialog({
          title: this.translateService.instant(
            'taskmodule.task.offer.ordered_addendum_offer.dialog_title'
          ),
          noEntriesMessage: this.translateService.instant(
            'taskmodule.task.offer.ordered_addendum_offer.no_entry'
          ),
          quotations: latestAcceptedAddendumQuotation
            ? [latestAcceptedAddendumQuotation]
            : [],
          serviceLineColumns: columnsToUse,
          fmIncidentArchObj: this.task.incident.fmIncidentArchObj || [],
          isDummyFrameworkContract: this.isDummyFrameworkContract,
          equipmentByArchObjId: this.equipmentService.buildEquipmentByArchObjId(
            this.task
          ),
          equipmentColumns: this.equipmentService.buildEquipmentColumns({
            includeDocumentation: false,
          }),
        });
      });
  }

  private openPreviousOffersDialog(data: unknown): void {
    if (this.previousOffersDialogRef) {
      return;
    }

    this.previousOffersDialogRef = this.dialog.open(
      PreviousOffersDialogComponent,
      {
        panelClass: 'smartportal-dialog',
        width: '900px',
        maxHeight: '90vh',
        data,
      }
    );

    this.previousOffersDialogRef
      .afterClosed()
      .pipe(first())
      .subscribe(() => {
        this.previousOffersDialogRef = null;
      });
  }

  private enrichArchObjDataBeforeDialog(
    quotationRequests: any[] | null,
    quotations: FmQuotation[] | null
  ): Observable<void> {
    const allLines: any[] = [];

    if (quotationRequests) {
      quotationRequests.forEach(req => {
        allLines.push(...(req.fmQuotationRequestLine || []));
      });
    }

    if (quotations) {
      quotations.forEach(q => {
        allLines.push(...(q.fmQuotationLine || []));
      });
    }

    const missingArchObjIds = Array.from(
      new Set(
        allLines
          .filter(
            line =>
              !!line?.archObjId &&
              !this.getArchObjFromIncident(line.archObjId)?.dtArchObjAddress
          )
          .map(line => line.archObjId as string)
      )
    );

    if (missingArchObjIds.length === 0) {
      return of(void 0);
    }

    return forkJoin(
      missingArchObjIds.map(archObjId =>
        this.locationClient.getArchobjById(archObjId).pipe(
          take(1),
          catchError(() => of(null))
        )
      )
    ).pipe(
      map(results => {
        const archObjMap = new Map<string, any>(
          results
            .filter(result => !!result)
            .map((result: any, index: number) => [
              missingArchObjIds[index],
              result,
            ])
        );

        const existingArchObj = Array.isArray(
          this.task.incident.fmIncidentArchObj
        )
          ? [...this.task.incident.fmIncidentArchObj]
          : [];

        const archObjMapById = new Map<string, any>(
          existingArchObj
            .filter((entry: any) => !!(entry?.archObjId || entry?.id))
            .map((entry: any) => [entry.archObjId || entry.id, entry])
        );

        archObjMap.forEach((archObj, archObjId) => {
          const existing = archObjMapById.get(archObjId);
          if (existing) {
            existing.dtArchObjAddress = archObj.dtArchObjAddress;
          } else {
            archObjMapById.set(archObjId, { id: archObjId, ...archObj });
          }
        });

        this.task.incident.fmIncidentArchObj = Array.from(
          archObjMapById.values()
        );
      })
    );
  }

  private getArchObjFromIncident(archObjId: string): any | null {
    return (
      this.task.incident.fmIncidentArchObj?.find(
        (obj: any) => obj.id === archObjId || obj.archObjId === archObjId
      ) || null
    );
  }

  private showErrorToastLoadTask() {
    this.toastr.error(
      this.translateService.instant('crud.details.error.failed_to_load_msg'),
      this.translateService.instant('crud.details.error.failed_to_load_title')
    );
  }

  private showErrorToastUpdateTask() {
    this.task7AutoCloseTriggered = false;
    this.toastr.error(
      this.translateService.instant('crud.update.error.failed_to_update_msg'),
      this.translateService.instant('crud.update.error.failed_to_update_title')
    );
  }

  private showSuccessToastUpdateTask() {
    if (this.task7AutoCloseTriggered) {
      this.task7AutoCloseTriggered = false;
      this.toastr.success(
        'Die Aufgabe wurde erfolgreich abgeschlossen.',
        this.translateService.instant('crud.update.success.sucess_update_title')
      );
      return;
    }

    this.toastr.success(
      this.translateService.instant('crud.update.success.sucess_update_msg'),
      this.translateService.instant('crud.update.success.sucess_update_title')
    );
  }

  viewDetailsTask = false;

  submit() {
    if (!this.task || !this.task.incidentId) {
      return;
    }

    this.cd.detectChanges();

    const newStatus = (this.form.value as any).newStatus;

    if (!this.validateCompletionDateForFullyCompletedServiceLocations()) {
      return;
    }

    if (!this.validateTask11PurchaseOrderServiceAcceptanceForCompletion()) {
      return;
    }

    if (newStatus === TaskStatus.Abgeschlossen) {
      const taskClosedDialog: MatDialogRef<DialogComponent> = this.dialog.open(
        DialogComponent,
        {
          panelClass: 'smartportal-dialog',
          width: '500px',
          data: {
            type: 'okDismissButton',
            title: 'Aufgabe wird abgeschlossen',
            message:
              'Abgeschlossene oder stornierte Aufgaben können nicht mehr bearbeitet werden und werden in der Übersicht nicht mehr angezeigt.',
            okButtonText: 'Jetzt senden',
            dismissButtonText: 'Abbrechen',
          },
        }
      );

      taskClosedDialog
        .afterClosed()
        .pipe(first())
        .subscribe({
          next: res => {
            if (!res) {
              this.isLoading = false;
              this.cd.detectChanges();
              return;
            }
            this.viewDetailsTask = true;
            this.send();
          },
        });
    } else if (newStatus === TaskStatus.Storniert) {
      this.viewDetailsTask = true;
      this.send();
    } else if (
      newStatus === TaskStatus.InBearbeitung &&
      this.isTask7ExecuteOptionalService &&
      this.isServiceRegistrationModeActive
    ) {
      const completedGroups = this.getFullyCompletedServiceRegistrationGroups();

      if (completedGroups.length > 0) {
        const locationListItems = completedGroups
          .map(g => {
            const address = g.archObj?.dtArchObjAddress?.[0]?.address;
            const street = address?.streetName
              ? `${address.streetName} ${address.houseNumber ?? ''}`.trim()
              : '';
            const city = address?.city
              ? `${address.postalCode ?? ''} ${address.city}`.trim()
              : '';
            const label = [street, city].filter(Boolean).join(', ');
            return `<li>[${g.archObjId}]${label ? ' ' + label : ''}</li>`;
          })
          .join('');
        const serviceRegistrationConfirmDialog: MatDialogRef<DialogComponent> =
          this.dialog.open(DialogComponent, {
            panelClass: 'smartportal-dialog',
            width: '560px',
            data: {
              type: 'okDismissButton',
              title: 'Leistungserfassung bestätigen',
              message: `Für folgende Standorte wurden alle Leistungen als erledigt markiert:<ul>${locationListItems}</ul><br>Soll die Leistungserfassung für diese Standorte durchgeführt werden?`,
              okButtonText: 'Ja, speichern',
              dismissButtonText: 'Abbrechen',
            },
          });
        serviceRegistrationConfirmDialog
          .afterClosed()
          .pipe(first())
          .subscribe({
            next: res => {
              if (!res) {
                this.isLoading = false;
                this.cd.detectChanges();
                return;
              }

              void this.executeServiceRegistrationRequests({
                keepLoadingState: true,
                showSuccessToast: false,
              })
                .then(() => {
                  this.viewDetailsTask = false;
                  this.send();
                })
                .catch(err => {
                  console.error(err);
                  this.isLoading = false;
                  this.showErrorToastUpdateTask();
                  this.cd.detectChanges();
                });
            },
          });
      } else {
        this.send();
      }
    } else {
      this.send();
    }
  }

  private validateTask11PurchaseOrderServiceAcceptanceForCompletion(): boolean {
    if (!this.isTask11SubmitInvoiceToScanCenter) {
      return true;
    }

    const newStatus = (this.form.value as any)?.newStatus;
    if (newStatus !== TaskStatus.Abgeschlossen) {
      return true;
    }

    const purchaseOrders = this.task?.incident?.fmPurchaseOrder || [];
    const purchaseOrdersWithoutCompletion = purchaseOrders.filter(
      purchaseOrder => purchaseOrder?.serviceAcceptanceCompleted !== true
    );

    if (purchaseOrdersWithoutCompletion.length === 0) {
      return true;
    }

    const missingOrderNumbers = purchaseOrdersWithoutCompletion
      .map(purchaseOrder => purchaseOrder?.orderNumber)
      .filter((orderNumber): orderNumber is string => !!orderNumber)
      .filter(
        (orderNumber, index, allOrderNumbers) =>
          allOrderNumbers.indexOf(orderNumber) === index
      )
      .join(', ');

    this.toastr.error(
      `Aufgabe 11 kann erst abgeschlossen werden, wenn zu allen Bestellungen die Leistungsabnahme abgeschlossen wurde.${missingOrderNumbers ? ` Fehlende Bestellungen: ${missingOrderNumbers}` : ''}`
    );
    this.isLoading = false;
    this.cd.detectChanges();
    return false;
  }

  private send() {
    this.isLoading = true;

    if (this.task && this.task.taskId) {
      const { result, validUntil, newStatus, cancelStatus } = this.form
        .value as any;

      const updateTaskDto: UpdateTaskDTO = {
        result: result,
        status: newStatus,
        taskId: this.task.taskId,
        updateIncidentDTO: this.generateUpdateIncidentDTO(),
        cancelStatus: cancelStatus ? cancelStatus.id : null,
        serviceProviderId:
          this.form.value['serviceProviderSelection']?.searchResult?.id ||
          this.task?.incident?.fmServiceRequestExternal?.serviceProvider
            ?.organisationId ||
          null,
      };

      // Check if offer was submitted (edited locations exist)
      const hasOfferPositions = this.editedLocations.length > 0;
      const shouldHandleOfferSubmission =
        hasOfferPositions &&
        !this.isTask11SubmitInvoiceToScanCenter &&
        (!this.isTask7ExecuteOptionalService ||
          newStatus === TaskStatus.Nachtragsangebot);

      if (newStatus !== TaskStatus.Storniert) {
        if (hasOfferPositions && this.isTask2EvaluateOffersAndCreateSuppliers) {
          const updates = this.editedLocations.map(location => {
            const isNewLocation = 'isNew' in location && !!location.isNew;

            return {
              id: location.id,
              quantity: location.quantity,
              unitPrice: location.unitPrice,
              priceNegotiated: (location as any).priceNegotiated,
              ...(isNewLocation
                ? {
                    description: location.name,
                    recordNumber: location.recordNumber,
                    unitId: location.unitId,
                    archObjId: location.archObjId,
                    isPurchasingDepartmentPosition: true,
                  }
                : {}),
            };
          }) as IncidentServiceLineUpdate[];

          const updateRequest: UpdateIncidentServiceLinesRequest = {
            incidentId: this.task.incidentId,
            updates: updates,
          };

          this.incidentClient
            .updateIncidentServiceLines(updateRequest)
            .pipe(
              catchError(err => {
                if (err?.status === 204) {
                  console.log(
                    '✓ IncidentServiceLines updated successfully (204 No Content)'
                  );
                  return of(null);
                }
                throw err;
              }),
              switchMap(() => {
                return this.taskClient.updateTask(updateTaskDto);
              }),
              take(1),
              finalize(() => console.log('Observable completed'))
            )
            .subscribe({
              next: () => {
                this.checkIsTaskUpdated();
              },
              error: err => {
                console.error(err);
                this.isLoading = false;
                this.showErrorToastUpdateTask();
                this.cd.detectChanges();
                window.location.reload();
              },
            });
          return;
        }

        if (shouldHandleOfferSubmission) {
          // Task 7: Create new addendum offer without quotationRequestId
          if (
            newStatus === TaskStatus.Nachtragsangebot &&
            this.isTask7ExecuteOptionalService
          ) {
            const validUntilDate = this.parseDateStringToDate(validUntil);
            const validUntilIso =
              validUntilDate && !isNaN(validUntilDate.getTime())
                ? validUntilDate.toISOString().split('T')[0]
                : undefined;

            const addendumQuotation: Quotation = {
              id: null,
              incidentId: this.task?.incidentId,
              quotationRequestId: null,
              title: this.task?.incident?.name || 'Nachtragsangebot',
              date: new Date().toISOString().split('T')[0] as any,
              validUntil: validUntilIso as any,
              typeId: this.quotationService.addendumOfferTypeId,
              serviceProviderComment:
                this.formModel?.serviceProviderCommentAddendum || '',
              lines: this.editedLocations.map(
                (location, index) =>
                  ({
                    id: null,
                    quotationRequestLineId: null,
                    archObjId: location.archObjId,
                    name: location.name || location.description,
                    quantity: location.quantity,
                    unitPrice: location.unitPrice,
                    unitId: location.unitId,
                    recordNumber: location.recordNumber || index + 1,
                    serviceProviderComment: location.serviceProviderComment,
                  }) as QuotationLine
              ),
            };

            this.quotationClient
              .createOrUpdateQuotation(true, addendumQuotation)
              .pipe(
                catchError(err => {
                  // Status 204 (No Content) is actually a success
                  if (err?.status === 204) {
                    console.log(
                      '✓ Addendum Quotation created successfully (204 No Content)'
                    );
                    return of(null);
                  }
                  throw err;
                }),
                take(1),
                finalize(() => console.log('Observable completed'))
              )
              .subscribe({
                next: () => {
                  this.hasSubmittedAddendumOfferLocally = true;
                  this.restoreNewStatusSelection(TaskStatus.InBearbeitung);
                  this.syncAddendumUiState();
                  this.toastr.success(
                    this.translateService.instant(
                      'taskmodule.task.offer.addendum_offer_success_toast'
                    )
                  );
                  this.isLoading = false;
                  this.cd.detectChanges();
                },
                error: err => {
                  console.error(err);
                  this.isLoading = false;
                  this.showErrorToastUpdateTask();
                  this.cd.detectChanges();
                  window.location.reload();
                },
              });
            return;
          }

          const allQuotationRequests =
            this.task?.incident?.fmQuotationRequest || [];
          const sortedQuotationRequests = [...allQuotationRequests].sort(
            (a, b) =>
              new Date(b.changeDate || 0).getTime() -
              new Date(a.changeDate || 0).getTime()
          );
          const quotationRequest = sortedQuotationRequests[0];
          const quotationRequestId = quotationRequest?.id;

          if (
            !quotationRequestId &&
            this.isTask2EvaluateOffersAndCreateSuppliers
          ) {
            updateTaskDto.updateIncidentDTO = {
              incident: {
                ...updateTaskDto.updateIncidentDTO?.incident,
                name: this.task?.incident?.name,
                incidentId: this.task?.incident?.incidentId,
                fmIncidentServiceLine: this.editedLocations.map(location => ({
                  id: location.id,
                  incidentId: this.task?.incident?.incidentId,
                  archObjId: location.archObjId,
                  name: location.name || location.description,
                  description: location.description,
                  quantity: location.quantity,
                  unitPrice: location.unitPrice,
                  unitId: location.unitId,
                  recordNumber: location.recordNumber,
                })) as FmIncidentServiceLine[],
              },
              fieldMapping: this.extension || [],
            };

            this.taskClient
              .updateTask(updateTaskDto)
              .pipe(take(1))
              .subscribe({
                next: () => {
                  this.checkIsTaskUpdated();
                },
                error: err => {
                  console.error(err);
                  this.isLoading = false;
                  this.showErrorToastUpdateTask();
                  this.cd.detectChanges();
                  window.location.reload();
                },
              });
            return;
          }

          if (quotationRequestId) {
            // Determine submit parameter based on new status
            const shouldSubmitQuotation =
              newStatus === TaskStatus.Abgeschlossen;
            const latestQuotation = quotationRequest?.fmQuotation?.[0];
            const validUntilDate = this.parseDateStringToDate(validUntil);

            const quotation: Quotation = {
              id:
                latestQuotation?.quotationRequestId === quotationRequestId
                  ? latestQuotation?.id || null
                  : null,
              incidentId: this.task?.incidentId,
              quotationRequestId: quotationRequestId,
              title: this.task?.incident?.name || 'Angebot',
              date: new Date().toISOString().split('T')[0] as any,
              validUntil: new Date(validUntilDate)
                .toISOString()
                .split('T')[0] as any,
              typeId: this.quotationService.mainOfferTypeId,
              lines: this.editedLocations.map((location, index) => {
                // Check if this is an existing QuotationLine (has quotationId)
                // vs a QuotationRequestLine or a newly created line
                const isExistingQuotationLine =
                  'quotationId' in location && location.quotationId;

                // For existing QuotationLines: use the existing id and quotationRequestLineId
                // For QuotationRequestLines: id becomes quotationRequestLineId, no line id yet
                // For new lines (isNew): no ids at all
                return {
                  id: isExistingQuotationLine ? location.id || null : null,
                  quotationRequestLineId: isExistingQuotationLine
                    ? location.quotationRequestLineId || null
                    : location.isNew
                      ? null
                      : location.id || null,
                  archObjId: location.archObjId,
                  name: location.name || location.description,
                  quantity: location.quantity,
                  unitPrice: location.unitPrice,
                  unitId: location.unitId,
                  recordNumber: location.recordNumber || index + 1,
                  serviceProviderComment: location.serviceProviderComment,
                } as QuotationLine;
              }),
            };

            this.quotationClient
              .createOrUpdateQuotation(shouldSubmitQuotation, quotation)
              .pipe(
                catchError(err => {
                  // Status 204 (No Content) is actually a success
                  if (err?.status === 204) {
                    console.log(
                      '✓ Quotation created/updated successfully (204 No Content)'
                    );
                    return of(null);
                  }
                  throw err;
                }),
                switchMap(() => {
                  return this.taskClient.updateTask(updateTaskDto);
                }),
                take(1),
                finalize(() => console.log('Observable completed'))
              )
              .subscribe({
                next: () => {
                  this.checkIsTaskUpdated();
                },
                error: err => {
                  console.error(err);
                  this.isLoading = false;
                  this.showErrorToastUpdateTask();
                  this.cd.detectChanges();
                  window.location.reload();
                },
              });
          } else {
            console.error('quotationRequestId nicht gefunden');
            this.isLoading = false;
            this.showErrorToastUpdateTask();
          }
        } else {
          // Standard Update ohne Quotation
          if (this.isTask7ExecuteOptionalService) {
            this.runSaveActionWithOptionalServiceRegistration(() => {
              this.taskClient
                .updateTask(updateTaskDto)
                .pipe(take(1))
                .subscribe({
                  next: () => {
                    this.checkIsTaskUpdated();
                  },
                  error: err => {
                    console.error(err);
                    this.isLoading = false;
                    this.showErrorToastUpdateTask();
                    this.cd.detectChanges();
                    window.location.reload();
                  },
                });
            });
          } else {
            this.taskClient
              .updateTask(updateTaskDto)
              .pipe(take(1))
              .subscribe({
                next: () => {
                  this.checkIsTaskUpdated();
                },
                error: err => {
                  console.error(err);
                  this.isLoading = false;
                  this.showErrorToastUpdateTask();
                  this.cd.detectChanges();
                  window.location.reload();
                },
              });
          }
        }
      } else {
        this.taskClient
          .updateTask(updateTaskDto)
          .pipe(take(1))
          .subscribe({
            next: () => {
              this.checkIsTaskUpdated();
            },
            error: err => {
              console.error(err);
              this.isLoading = false;
              this.showErrorToastUpdateTask();
              this.cd.detectChanges();
              window.location.reload();
            },
          });
      }
    }
  }

  private checkIsTaskUpdated() {
    const request: CheckForTaskUpdateRequest = {
      id: this.task.taskId,
      modifiedOn: this.task.modifiedOn,
    };

    setTimeout(() => {
      this.taskClient.isTaskUpdated(request).subscribe({
        next: response => {
          if (!response) {
            this.checkIsTaskUpdated();
            return;
          }

          setTimeout(() => {
            this.isLoading = false;
            if (this.viewDetailsTask) {
              this.router.navigate([`/task/viewDetails/${this.task.taskId}`], {
                state: {
                  originRoute: this.originRoute,
                },
              });
            } else {
              window.location.reload();
            }
            this.showSuccessToastUpdateTask();
            this.cd.detectChanges();
          }, 7000);
        },
        error: err => {
          console.error(err);
          this.checkIsTaskUpdated();
        },
      });
    }, 1000);
  }

  private generateUpdateIncidentDTO(): UpdateIncidentDTO {
    const areasReturnDateLessorDateString =
      this.form.value[this.updateIncidentRentalContractMngmnt]
        ?.areasReturnDateLessor;

    let areasReturnDateLessorDateObject = null;

    const dateArray = areasReturnDateLessorDateString?.split('.');
    if (dateArray) {
      const year = Number(dateArray[2]);
      const month = Number(dateArray[1]) - 1;
      const day = Number(dateArray[0]);

      areasReturnDateLessorDateObject = new Date(year, month, day);
    }

    const el: PmIncidentExternalLetting = {
      incidentId: this.task?.incident?.incidentId,
      ...this.form.value[this.updateIncidentExternalLetting],
    };
    const red: PmIncidentRealEstateDecision = {
      incidentId: this.task?.incident?.incidentId,
      ...this.form.value[this.updateIncidentRealEstateDecision],
    };
    const rcm: PmIncidentRentalContractMgmt = {
      incidentId: this.task?.incident?.incidentId,
      ...this.form.value[this.updateIncidentRentalContractMngmnt],
      areasReturnDateLessor: areasReturnDateLessorDateObject,
    };

    const incidentDto: FmIncident = {
      name: this.task?.incident?.name,
      incidentId: this.task?.incident?.incidentId,
      pmIncidentExternalLetting: this.form.value[
        this.updateIncidentExternalLetting
      ]
        ? el
        : null,
      pmIncidentRealEstateDecision: this.form.value[
        this.updateIncidentRealEstateDecision
      ]
        ? red
        : null,
      pmIncidentRentalContractMgmtIdNavigation: this.form.value[
        this.updateIncidentRentalContractMngmnt
      ]
        ? rcm
        : null,
      ...this.form.value[this.updateIncidentFieldGroupName],
    };
    return {
      incident: incidentDto,
      fieldMapping: this.extension || [],
    };
  }

  private fillIncidentAttributeForm() {
    if (
      !this.task ||
      !this.task.configurationTask ||
      !this.task.configurationTask.fmConfigurationRow ||
      !this.task.incident ||
      this.task.configurationTask.fmConfigurationRow.length <= 0
    ) {
      return;
    }

    // add chapter title
    this.formFields.push({
      type: 'chapter',
      props: {
        chapterTitle: this.translateService.instant(
          'taskmodule.task.update.update_incident_fields'
        ),
      },
    });

    // generate emtpy FormGroup for the incident fields
    const updateIncidentFormGroup: {
      key: string;
      fieldGroup: Array<any>;
    } & FormlyFieldConfig = {
      key: this.updateIncidentFieldGroupName,
      fieldGroup: [],
    };

    const updateIncidentExternalLettingFormGroup: {
      key: string;
      fieldGroup: Array<any>;
    } & FormlyFieldConfig = {
      key: this.updateIncidentExternalLetting,
      fieldGroup: [],
    };

    const updateIncidentRealEstateDecisionFormGroup: {
      key: string;
      fieldGroup: Array<any>;
    } & FormlyFieldConfig = {
      key: this.updateIncidentRealEstateDecision,
      fieldGroup: [],
    };

    const updateIncidentRentalContractMngmntFormGroup: {
      key: string;
      fieldGroup: Array<any>;
    } & FormlyFieldConfig = {
      key: this.updateIncidentRentalContractMngmnt,
      fieldGroup: [],
    };

    // populate FormGroup with proper typed input fields
    for (const row of this.task.configurationTask.fmConfigurationRow) {
      // push config row form field
      if (row.targetEntity == null) {
        updateIncidentFormGroup.fieldGroup.push(
          this.generateConfigurationRowField(row)
        );
      } else if (row.targetEntity == 'affinis_incidentrealestatedecision') {
        updateIncidentRealEstateDecisionFormGroup.fieldGroup.push(
          this.generateConfigurationRowField(row)
        );
      } else if (row.targetEntity == 'affinis_incidentexternalletting') {
        updateIncidentExternalLettingFormGroup.fieldGroup.push(
          this.generateConfigurationRowField(row)
        );
      } else if (
        row.targetEntity == 'affinis_incidentrentalcontractmanagement'
      ) {
        updateIncidentRentalContractMngmntFormGroup.fieldGroup.push(
          this.generateConfigurationRowField(row)
        );
      }
    }

    // push the formGroup in the parent formFields
    if (updateIncidentFormGroup.fieldGroup.length > 0) {
      this.formFields.push(updateIncidentFormGroup);
    }
    if (updateIncidentRealEstateDecisionFormGroup.fieldGroup.length > 0) {
      this.formFields.push(updateIncidentRealEstateDecisionFormGroup);
    }
    if (updateIncidentExternalLettingFormGroup.fieldGroup.length > 0) {
      this.formFields.push(updateIncidentExternalLettingFormGroup);
    }
    if (updateIncidentRentalContractMngmntFormGroup.fieldGroup.length > 0) {
      this.formFields.push(updateIncidentRentalContractMngmntFormGroup);
    }
  }

  private firstLowercase(theString: string): string {
    return theString.charAt(0).toLowerCase() + theString.slice(1);
  }

  private generateConfigurationRowField(
    row: FmConfigurationRow
  ): FormlyFieldConfig {
    if (!this.extension || !row.name || !this.task || !this.task.incident) {
      throw new Error('An Error occured in generateField');
    }

    // get mapping for fieldType of the configuration row
    const incidentFieldMapping: IncidentFieldMapping | null =
      this.extension.find(e => e.ibpdiAttributeName === row.name) || null;

    if (!incidentFieldMapping) {
      throw new Error('missing incidentFieldMapping');
    }

    const label: string = this.translateDataService.translate(
      row.titleDe,
      row.titleEn
    );

    const key: string = this.firstLowercase(row.name);

    const fieldType: string = incidentFieldMapping
      ? incidentFieldMapping.ibpdiAttributeType
      : '';

    // prefill field value with value in incident
    let defaultValue = null;

    if (incidentFieldMapping.targetEntity == null) {
      defaultValue = this.task.incident[key] || null;
    } else if (
      incidentFieldMapping.targetEntity == 'affinis_incidentrealestatedecision'
    ) {
      defaultValue =
        this.task.incident.pmIncidentRealEstateDecision[key] || null;
    } else if (
      incidentFieldMapping.targetEntity == 'affinis_incidentexternalletting'
    ) {
      defaultValue = this.task.incident.pmIncidentExternalLetting[key] || null;
    } else if (
      incidentFieldMapping.targetEntity ==
      'affinis_incidentrentalcontractmanagement'
    ) {
      defaultValue =
        this.task.incident.pmIncidentRentalContractMgmtIdNavigation[key] ||
        null;
    }

    if (fieldType.includes('String')) {
      return this.generateTextField(key, label, defaultValue);
    }
    if (fieldType.includes('DateTime')) {
      return this.generateDateField(key, label, defaultValue);
    }
    if (fieldType.includes('Int')) {
      return this.generateIntField(key, label, defaultValue);
    }
    if (fieldType.includes('Decimal')) {
      return this.generateDecimalField(key, label, defaultValue);
    }
    if (fieldType.includes('SysEnum')) {
      if (!incidentFieldMapping.optionSetType) {
        throw new Error('Missing optionSetType');
      }
      return this.generateOptionSetField(
        incidentFieldMapping.optionSetType,
        defaultValue,
        key,
        label
      );
    }
    if (fieldType.includes('Boolean')) {
      return this.generateBooleanField(key, label, defaultValue);
    }
    throw new Error(`Unknown fieldType: ${fieldType}`);
  }

  public generateTextField(
    key = '--',
    label = '--',
    defaultValue = '',
    maxLength = 100
  ): FormlyFieldConfig {
    return {
      key,
      type: 'input',
      defaultValue,
      props: {
        required: this.masterRequired,
        label,
        maxLength,
      },
    };
  }

  private generateDateField(
    key = '--',
    label = '--',
    defaultValue = ''
  ): FormlyFieldConfig {
    return {
      key,
      type: 'input',
      defaultValue: defaultValue
        ? this.formatDateString(new Date(defaultValue))
        : '',
      validation: {
        messages: {
          invalidDate: 'Ungültiges Datum / Datumsformat (TT.MM.JJJJ)',
        },
      },
      props: {
        required: this.masterRequired,
        label,
        placeholder: 'TT.MM.JJJJ',
        focus: res => {
          res.formControl.setErrors(
            this.handleDateInput(res.formControl.value)
          );
        },
        blur: res => {
          res.formControl.setErrors(
            this.handleDateInput(res.formControl.value)
          );
        },
      },
    };
  }

  private generateIntField(
    key = '--',
    label = '--',
    defaultValue = ''
  ): FormlyFieldConfig {
    return {
      key,
      type: 'input',
      defaultValue,
      props: {
        type: 'number',
        label,
        required: this.masterRequired,
      },
    };
  }

  private generateDecimalField(
    key = '--',
    label = '--',
    defaultValue = ''
  ): FormlyFieldConfig {
    return {
      key,
      type: 'input',
      defaultValue,
      props: {
        type: 'number',
        label,
        required: this.masterRequired,
        step: 0.01,
      },
    };
  }

  private generateOptionSetField(
    optionSetType: string,
    defaultValue: SysEnum,
    key = '--',
    label = '--'
  ): FormlyFieldConfig {
    // fixes requiredness of sysEnumTranslation.name
    if (defaultValue) {
      delete defaultValue.sysEnumTranslation;
    }

    return {
      key,
      type: 'select',
      defaultValue,
      //wrappers: ['loading-suffix'],
      props: {
        loading: false,
        readonly: false,
        compareWith(o1: any, o2: any) {
          return o1?.id === o2?.id;
        },
        label,
        required: this.masterRequired,
      },
      hooks: {
        onInit: (field: FormlyFieldConfig | undefined) => {
          if (!field || !field.props) {
            return;
          }
          const f = field.props;
          f.loading = true;
          f.readonly = true;
          this.cd.detectChanges();

          this.optionSetClient
            .getOptionSetByString(optionSetType)
            .pipe(
              first(),
              map(sysEnums => {
                return sysEnums.map((sysEnum: SysEnum) => {
                  delete sysEnum.sysEnumTranslation;
                  const s = { ...sysEnum };
                  return {
                    label:
                      this.ibpdiHelperService.getTranslatedEnumLable(sysEnum),
                    value: s,
                  };
                });
              })
            )
            .subscribe({
              next: options => {
                // sysEnumTranslation:null fixes requiredness of sysEnumTranslation.name
                if (defaultValue) {
                  delete defaultValue.sysEnumTranslation;
                }

                f.options = options;
                this.form.patchValue({
                  [this.updateIncidentFieldGroupName]: { [key]: defaultValue },
                });
                f.loading = false;
                f.readonly = false;
                this.cd.detectChanges();
              },
              error: error => {
                this.showErrorToastLoadTask();
                console.error(error);
              },
            });
        },
      },
    };
  }

  private generateBooleanField(
    key = '--',
    label = '--',
    defaultValue: boolean | null | string = null
  ): FormlyFieldConfig {
    if (defaultValue === '') {
      defaultValue = null;
    }

    const options: { id: number; label: string; value: boolean }[] = [
      { id: 1, label: this.translate('label__choice_yes'), value: true },
      { id: 2, label: this.translate('label__choice_no'), value: false },
    ];

    return {
      key,
      type: 'select',
      defaultValue,
      props: {
        options,
        label,
        required: this.masterRequired,
      },
    };
  }

  public translate(key: string) {
    return this.translateService.instant(`taskmodule.shared.${key}`);
  }

  public recordProspectiveTenants() {
    let locationSiteCode;
    let locationWeNo;
    let addressCity;
    let addressStreet;

    this.locationClient
      .getArchobjById(this.task?.incident?.archObjId)
      .subscribe({
        next: res => {
          locationSiteCode = res.dtSite?.siteCode;
          locationWeNo = res.id;
          addressCity = res.dtArchObjAddress
            ? res.dtArchObjAddress[0].address?.city
            : null;
          addressStreet = res.dtArchObjAddress
            ? res.dtArchObjAddress[0].address?.streetName
            : null;
          this.dialog.open(ProspectiveTenantsTelekomComponent, {
            width: '50vw',
            data: {
              siteCode: locationSiteCode,
              weNo: locationWeNo,
              city: addressCity,
              street: addressStreet,
              incidentId: this.task?.incidentId,
            },
          });
        },
      });
  }

  getSubIncidents() {
    const incidentId = this.task?.incidentId;

    if (!incidentId) {
      this.dataProspectiveTenantsList$ = of([]);
      return;
    }

    this.dataProspectiveTenantsList$ = this.incidentClient
      .getSubIncidents(incidentId)
      .pipe(
        take(1),
        catchError(() => of([])),
        shareReplay({ bufferSize: 1, refCount: true })
      );
  }

  private isValidDate(dateInput: any): boolean {
    if (!dateInput) return false;

    const m = moment(dateInput, 'DD.MM.YYYY', true);

    if (!m.isValid()) {
      return false;
    }

    const year = m.year();
    return year <= 9999;
  }

  private handleDateInput(dateString: string) {
    if (!dateString) {
      return null;
    }

    if (!this.isValidDate(dateString)) {
      return { invalidDate: true };
    } else {
      return null;
    }
  }

  private parseDateStringToDate(
    dateInput: string | Date | any | null | undefined
  ): Date | undefined {
    if (!dateInput) return undefined;

    if (dateInput instanceof Date) return dateInput;

    if (dateInput._isAMomentObject) return dateInput.toDate();

    if (typeof dateInput === 'string') {
      if (dateInput.includes('-')) {
        return new Date(dateInput);
      }

      if (!this.isValidDate(dateInput)) return undefined;

      const [day, month, year] = dateInput.split('.').map(Number);
      return new Date(year, month - 1, day);
    }

    return undefined;
  }

  private formatDateString(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }

  private getFullyCompletedServiceRegistrationGroups(): {
    archObjId: string;
    archObj: any;
  }[] {
    if (!this.serviceRegistrationLocations?.length) {
      return [];
    }

    const grouped = new Map<
      string,
      { archObjId: string; archObj: any; rows: any[] }
    >();
    for (const location of this.serviceRegistrationLocations) {
      const archObjId =
        location.archObjId || location.archObj?.archObjId || 'unknown';
      if (!grouped.has(archObjId)) {
        grouped.set(archObjId, {
          archObjId,
          archObj: location.archObj,
          rows: [],
        });
      }
      grouped.get(archObjId)!.rows.push(location);
    }

    return Array.from(grouped.values()).filter(g => {
      const relevantRows = g.rows.filter(row => {
        const quantity = parseFloat(String(row?.quantityProvided ?? 0)) || 0;
        return quantity > 0;
      });

      return (
        relevantRows.length > 0 &&
        relevantRows.every(row => !!row?.serviceReported)
      );
    });
  }

  private getServiceRegistrationCompletionSummary(): {
    totalGroupsRequiringServiceRegistration: number;
    completedGroups: number;
    pendingGroups: number;
  } {
    if (!this.serviceRegistrationLocations?.length) {
      return {
        totalGroupsRequiringServiceRegistration: 0,
        completedGroups: 0,
        pendingGroups: 0,
      };
    }

    const grouped = new Map<string, any[]>();

    for (const location of this.serviceRegistrationLocations) {
      const archObjId =
        location?.archObjId || location?.archObj?.archObjId || 'unknown';
      if (!grouped.has(archObjId)) {
        grouped.set(archObjId, []);
      }
      grouped.get(archObjId)!.push(location);
    }

    const groupsRequiringServiceRegistration = Array.from(grouped.values())
      .map(rows => {
        const relevantRows = rows.filter(row => {
          const orderedQuantity = parseFloat(String(row?.quantity ?? 0)) || 0;
          const quantityProvided =
            parseFloat(String(row?.quantityProvided ?? 0)) || 0;

          return orderedQuantity > 0 || quantityProvided > 0;
        });

        const isCompleted =
          relevantRows.length > 0 &&
          relevantRows.every(row =>
            this.isServiceRegistrationRowPersistedAsCompleted(row)
          );

        return {
          relevantRows,
          isCompleted,
        };
      })
      .filter(group => group.relevantRows.length > 0);

    const totalGroupsRequiringServiceRegistration =
      groupsRequiringServiceRegistration.length;
    const completedGroups = groupsRequiringServiceRegistration.filter(
      group => group.isCompleted
    ).length;

    return {
      totalGroupsRequiringServiceRegistration,
      completedGroups,
      pendingGroups: totalGroupsRequiringServiceRegistration - completedGroups,
    };
  }

  private isServiceRegistrationRowPersistedAsCompleted(row: any): boolean {
    if (row?._serviceReportedFromBackend !== undefined) {
      return !!row?._serviceReportedFromBackend;
    }

    return !!row?.serviceReported;
  }

  private markSubmittedServiceRegistrationRowsAsPersisted(
    includedQuotationLineIds?: Set<string>
  ): void {
    for (const location of this.serviceRegistrationLocations || []) {
      const quotationLineId =
        location?.quotationLineId ||
        location?.id ||
        location?.quotationRequestLineId;

      if (
        includedQuotationLineIds?.size &&
        (!quotationLineId || !includedQuotationLineIds.has(quotationLineId))
      ) {
        continue;
      }

      if (!!location?.serviceReported) {
        location._serviceReportedFromBackend = true;
      }
    }
  }

  private async tryAutoCloseTaskAfterLastServiceRegistration(beforeSummary: {
    totalGroupsRequiringServiceRegistration: number;
    completedGroups: number;
    pendingGroups: number;
  }): Promise<boolean> {
    if (!this.isTask7ExecuteOptionalService) {
      return false;
    }

    const afterSummary = this.getServiceRegistrationCompletionSummary();

    const allProcessedNow = afterSummary.pendingGroups === 0;
    const hadAnyGroupsToProcess =
      beforeSummary.totalGroupsRequiringServiceRegistration > 0;
    const shouldOpenAutoCloseDialog = hadAnyGroupsToProcess && allProcessedNow;

    if (!shouldOpenAutoCloseDialog) {
      return false;
    }

    this.restoreNewStatusSelection(TaskStatus.Abgeschlossen);
    this.syncTask7ResultFieldState(TaskStatus.Abgeschlossen);

    const resultControl = this.form.get('result');
    if (resultControl) {
      (resultControl as any).setValue(this.task7CompletedResultText, {
        emitEvent: false,
      });
    }

    this.formModel = {
      ...this.formModel,
      newStatus: TaskStatus.Abgeschlossen,
      result: this.task7CompletedResultText,
    };

    this.task7AutoCloseTriggered = true;

    this.viewDetailsTask = true;
    this.modelOnChange();
    this.cd.detectChanges();
    this.send();
    return true;
  }

  private getCompletedServiceRegistrationGroupsWithoutCompletionDate(group?: {
    rows?: any[];
  }): {
    archObjId: string;
    archObj: any;
    positionTypeLabel: string;
  }[] {
    if (!this.serviceRegistrationLocations?.length) {
      return [];
    }

    const groupQuotationLineIds = group?.rows?.length
      ? new Set(
          group.rows
            .map(
              row =>
                row?.quotationLineId || row?.id || row?.quotationRequestLineId
            )
            .filter((id): id is string => !!id)
        )
      : null;

    const grouped = new Map<
      string,
      { archObjId: string; archObj: any; rows: any[] }
    >();

    for (const location of this.serviceRegistrationLocations) {
      if (
        groupQuotationLineIds &&
        !groupQuotationLineIds.has(
          location?.quotationLineId ||
            location?.id ||
            location?.quotationRequestLineId
        )
      ) {
        continue;
      }
      const archObjId =
        location.archObjId || location.archObj?.archObjId || 'unknown';
      const isAddendum = !!location?.isAddendumServiceRegistrationPosition;
      const groupKey = `${archObjId}||${isAddendum ? 'addendum' : 'offer'}`;

      if (!grouped.has(groupKey)) {
        grouped.set(groupKey, {
          archObjId,
          archObj: location.archObj,
          rows: [],
        });
      }
      grouped.get(groupKey)!.rows.push(location);
    }
    return Array.from(grouped.values())
      .map(group => {
        const relevantRows = group.rows.filter(row => {
          const quantity = parseFloat(String(row?.quantityProvided ?? 0)) || 0;
          return quantity > 0;
        });

        return {
          ...group,
          rows: relevantRows,
        };
      })
      .filter(group => group.rows.length > 0)
      .filter(group => group.rows.every(row => !!row?.serviceReported))
      .filter(group =>
        group.rows.some(
          row =>
            !this.parseDateStringToDate(
              row?.serviceRegistrationCompletionDate ||
                row?.purchaseOrder?.completionDate
            )
        )
      )
      .map(group => {
        const hasAddendumPositions = group.rows.some(
          row => !!row?.isAddendumServiceRegistrationPosition
        );
        const hasOfferPositions = group.rows.some(
          row => !row?.isAddendumServiceRegistrationPosition
        );

        let positionTypeLabel = 'Angebotsposition';
        if (hasAddendumPositions) {
          positionTypeLabel = 'Nachtragsposition';
        }

        return {
          archObjId: group.archObjId,
          archObj: group.archObj,
          positionTypeLabel,
        };
      });
  }

  private validateCompletionDateForFullyCompletedServiceLocations(group?: {
    rows?: any[];
  }): boolean {
    if (!this.isTask7ExecuteOptionalService) {
      return true;
    }

    const completedGroupsWithoutCompletionDate =
      this.getCompletedServiceRegistrationGroupsWithoutCompletionDate(group);

    if (completedGroupsWithoutCompletionDate.length === 0) {
      return true;
    }

    const affectedArchObjIds = completedGroupsWithoutCompletionDate
      .map(group => `[${group.archObjId}] (${group.positionTypeLabel})`)
      .join(', ');

    this.toastr.error(
      `Bitte setzen Sie ein Fertigstellungsdatum für alle vollständig als erledigt markierten Standorte: ${affectedArchObjIds}`
    );
    this.isLoading = false;
    this.cd.detectChanges();
    return false;
  }

  private buildServiceRegistrationRequests(
    includedQuotationLineIds?: Set<string>
  ): Promise<UpdateServiceRegistrationRequest[]> {
    return this.buildServiceRegistrationRequestsInternal(
      includedQuotationLineIds
    );
  }

  private async buildServiceRegistrationRequestsInternal(
    includedQuotationLineIds?: Set<string>
  ): Promise<UpdateServiceRegistrationRequest[]> {
    const requestsByGroupKey = new Map<
      string,
      {
        quotationId: string;
        lines: UpdateServiceRegistrationLine[];
        completionDate?: Date;
      }
    >();

    for (const location of this.serviceRegistrationLocations || []) {
      const quotationId =
        location?.purchaseOrder?.quotationId || location?.quotationId;
      const quotationLineId = location?.quotationLineId || location?.id;

      if (
        includedQuotationLineIds?.size &&
        (!quotationLineId || !includedQuotationLineIds.has(quotationLineId))
      ) {
        continue;
      }

      const archObjId = location?.archObjId || location?.archObj?.archObjId;
      const isAddendumServiceRegistrationPosition =
        !!location?.isAddendumServiceRegistrationPosition;
      const quantity = parseFloat(String(location?.quantityProvided ?? 0)) || 0;

      if (!quotationId || !quotationLineId || quantity <= 0) {
        continue;
      }

      const requestGroupKey = isAddendumServiceRegistrationPosition
        ? `${quotationId}||${archObjId || quotationLineId}`
        : quotationId;

      const documents = await this.mapServiceRegistrationDocuments(
        location?.serviceRegistrationDocumentationFiles,
        location
      );
      const completionDate = this.parseDateStringToDate(
        location?.serviceRegistrationCompletionDate
      );

      const line: UpdateServiceRegistrationLine = {
        completed: location?.serviceReported ?? false,
        quantity,
        quotationLineId,
        comment: location?.serviceRegistrationCommentExternal || undefined,
        documents: documents.length > 0 ? documents : undefined,
      };

      if (!requestsByGroupKey.has(requestGroupKey)) {
        requestsByGroupKey.set(requestGroupKey, {
          quotationId,
          lines: [],
          completionDate,
        });
      }

      const requestEntry = requestsByGroupKey.get(requestGroupKey)!;
      requestEntry.lines.push(line);

      if (
        completionDate &&
        (!requestEntry.completionDate ||
          completionDate.getTime() > requestEntry.completionDate.getTime())
      ) {
        requestEntry.completionDate = completionDate;
      }
    }

    return Array.from(requestsByGroupKey.values())
      .filter(requestEntry => requestEntry.lines.length > 0)
      .map(requestEntry => ({
        quotationId: requestEntry.quotationId,
        lines: requestEntry.lines,
        completionDate: requestEntry.completionDate,
      }));
  }

  private applyServiceRegistrationCompletionDatesToLocalState(
    requests: UpdateServiceRegistrationRequest[]
  ): void {
    const completionDateByCompositeKey = new Map<string, string>();

    for (const request of requests || []) {
      const completionDate = request?.completionDate
        ? this.parseDateStringToDate(request.completionDate)
        : undefined;

      if (!completionDate) {
        continue;
      }

      const completionDateIso = completionDate.toISOString();

      for (const line of request?.lines || []) {
        const quotationLineId = line?.quotationLineId;
        if (!quotationLineId || !request?.quotationId) {
          continue;
        }

        const compositeKey = `${request.quotationId}||${quotationLineId}`;
        completionDateByCompositeKey.set(compositeKey, completionDateIso);
      }
    }

    if (!completionDateByCompositeKey.size) {
      return;
    }

    for (const location of this.serviceRegistrationLocations || []) {
      const quotationLineId = location?.quotationLineId || location?.id;
      const quotationId =
        location?.purchaseOrder?.quotationId || location?.quotationId;

      if (!quotationLineId || !quotationId) {
        continue;
      }

      const compositeKey = `${quotationId}||${quotationLineId}`;
      const completionDateIso = completionDateByCompositeKey.get(compositeKey);

      if (!completionDateIso) {
        continue;
      }

      location.purchaseOrder = location.purchaseOrder || {};
      location.purchaseOrder.completionDate = completionDateIso;

      location.serviceRegistrationCompletionDate = completionDateIso;
    }

    this.serviceRegistrationLocations = [
      ...(this.serviceRegistrationLocations || []),
    ];
    this.modelOnChange();
    this.cd.detectChanges();
  }

  private async mapServiceRegistrationDocuments(
    files: any,
    location: any
  ): Promise<UploadFile[]> {
    const sourceFiles: any[] = Array.isArray(files)
      ? files
      : files
        ? [files]
        : [];
    const result: UploadFile[] = [];

    for (const fileLike of sourceFiles) {
      const uploadFile = await this.toUploadFile2(fileLike, location);
      if (uploadFile) {
        result.push(uploadFile);
      }
    }

    return result;
  }

  private async toUploadFile2(
    fileLike: any,
    location: any
  ): Promise<UploadFile | null> {
    if (!fileLike) {
      return null;
    }

    if (fileLike.contentBase64Encoded && fileLike.metadata) {
      return fileLike as UploadFile;
    }

    const existingDocumentId =
      fileLike?.documentId ||
      fileLike?.metadata?.documentId ||
      fileLike?.file?.documentId;

    if (existingDocumentId) {
      const existingFileName =
        fileLike?.name ||
        fileLike?.filename ||
        fileLike?.file?.name ||
        'Dokument';
      const documentTypeId =
        fileLike?.documentTypeId ||
        this.task?.configurationTask?.defaultDocumentTypeId ||
        DocumentType.Sonstiges;
      const visibilityId =
        fileLike?.visibilityId || DocumentVisibility.InternAndContractors;

      return {
        // Backend validation requires this field to be non-empty,
        // even when an existing document is referenced via `documentId`.
        // `AA==` is the base64 encoding of a single zero byte placeholder.
        contentBase64Encoded: 'AA==',
        metadata: {
          documentId: existingDocumentId,
          name: existingFileName,
          filename: existingFileName,
          isInternal: false,
          statusCode: 'Aktiv',
          taskId: this.task?.taskId,
          incidentId: this.task?.incidentId,
          purchaseOrderId: location?.purchaseOrder?.id,
          documentTypeId,
          visibilityId,
        },
      };
    }

    const sourceFile: File | null =
      fileLike instanceof File
        ? fileLike
        : fileLike?.file instanceof File
          ? fileLike.file
          : null;

    if (!sourceFile) {
      return null;
    }

    const documentTypeId =
      fileLike?.documentTypeId ||
      this.task?.configurationTask?.defaultDocumentTypeId ||
      DocumentType.Sonstiges;
    const visibilityId =
      fileLike?.visibilityId || DocumentVisibility.InternAndContractors;

    const dataUrl = await this.readFileAsDataUrl(sourceFile);
    const contentBase64Encoded = dataUrl?.split(',')[1] || '';

    if (!contentBase64Encoded) {
      return null;
    }

    return {
      contentBase64Encoded,
      metadata: {
        name: sourceFile.name,
        filename: sourceFile.name,
        isInternal: false,
        statusCode: 'Aktiv',
        taskId: this.task?.taskId,
        incidentId: this.task?.incidentId,
        purchaseOrderId: location?.purchaseOrder?.id,
        documentTypeId,
        visibilityId,
        filesize: sourceFile.size,
        contentType: sourceFile.type || undefined,
      },
    };
  }

  private readFileAsDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ''));
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });
  }

  private isServiceRegistrationFullyCompleted(): boolean {
    if (!this.isTask7ExecuteOptionalService) {
      return true;
    }

    if (!this.serviceRegistrationLocations?.length) {
      return false;
    }

    return this.serviceRegistrationLocations.every(
      location => location?.serviceReported === true
    );
  }

  private updateAddendumSubmitButtonDisabledState(
    fields: FormlyFieldConfig[] = []
  ) {
    for (const field of fields) {
      if (field?.key === 'submitAddendumOfferButton') {
        field.props = {
          ...(field.props || {}),
          disabled: this.hasExistingAddendumOffer,
        };
      }

      if (field?.fieldGroup?.length) {
        this.updateAddendumSubmitButtonDisabledState(field.fieldGroup);
      }
    }
  }

  private syncAddendumUiState() {
    this.updateNewStatusFieldOptions(this.formFields);
    this.updateAddendumSubmitButtonDisabledState(this.formFields);
  }

  private getServiceLineColumnsForDummyOfferInquiry(
    hideServiceProviderComment = false
  ): any[] {
    return this.serviceLineColumns
      .map(col => {
        if (col.field === 'unitPrice') {
          return {
            ...col,
            formatter: (row: any) => {
              const isPriceNegotiated = !!row?.priceNegotiated;
              const unitPrice = parseFloat(row?.unitPrice) || 0;
              return `${formatPrice(isPriceNegotiated ? unitPrice : 0)} €`;
            },
          };
        }

        if (col.field === 'totalPrice') {
          return {
            ...col,
            formatter: (row: any) => {
              const isPriceNegotiated = !!row?.priceNegotiated;
              const quantity = parseFloat(row?.quantity) || 0;
              const unitPrice = isPriceNegotiated
                ? parseFloat(row?.unitPrice) || 0
                : 0;
              return `${formatPrice(quantity * unitPrice)} €`;
            },
          };
        }

        return col;
      })
      .filter(col =>
        hideServiceProviderComment
          ? col.field !== 'serviceProviderComment'
          : true
      );
  }

  private getQuotationLinesFromPurchaseOrder(
    purchaseOrder?: FmPurchaseOrder | any
  ): FmQuotationLine[] {
    if (!purchaseOrder) {
      return [];
    }

    const rawPurchaseOrderLines = purchaseOrder?.fmPurchaseOrderLine;
    const purchaseOrderLines: any[] = Array.isArray(rawPurchaseOrderLines)
      ? rawPurchaseOrderLines
      : rawPurchaseOrderLines
        ? [rawPurchaseOrderLines]
        : [];

    const purchaseOrderArchObjIds = new Set(
      purchaseOrderLines
        .map(purchaseOrderLine => purchaseOrderLine?.archObjId)
        .filter((archObjId): archObjId is string => !!archObjId)
    );

    const quotation = this.getQuotationForPurchaseOrder(purchaseOrder);

    if (quotation && this.isAddendumQuotation(quotation)) {
      return [];
    }

    const rawLines =
      quotation?.fmQuotationLine || (quotation as any)?.quotationLine;
    const quotationLines = Array.isArray(rawLines)
      ? rawLines
      : rawLines
        ? [rawLines]
        : [];

    if (purchaseOrderArchObjIds.size === 0) {
      return quotationLines;
    }

    return quotationLines.filter(quotationLine =>
      purchaseOrderArchObjIds.has(quotationLine?.archObjId)
    );
  }

  private getLatestAddendumQuotationLines(): FmQuotationLine[] {
    return getLatestAddendumQuotationLinesFromTask(
      this.task,
      this.quotationService.addendumOfferTypeId,
      true
    ) as FmQuotationLine[];
  }

  private getLatestAddendumQuotation(): FmQuotation | undefined {
    return getLatestAddendumQuotationFromTask(
      this.task,
      this.quotationService.addendumOfferTypeId
    );
  }

  private getLatestAcceptedAddendumQuotation(): FmQuotation | undefined {
    return getLatestAcceptedAddendumQuotationFromTask(
      this.task,
      this.quotationService.addendumOfferTypeId
    );
  }

  private getLatestAddendumStatusReason(): string {
    return getLatestAddendumStatusReasonFromTask(
      this.task,
      this.quotationService.addendumOfferTypeId
    );
  }

  private getIncidentQuotations(): FmQuotation[] {
    return getIncidentQuotationsFromTask(this.task) as FmQuotation[];
  }

  private getQuotationForPurchaseOrder(
    purchaseOrder?: FmPurchaseOrder | any
  ): FmQuotation | undefined {
    if (!purchaseOrder) {
      return undefined;
    }

    if (purchaseOrder?.quotation) {
      return purchaseOrder.quotation as FmQuotation;
    }

    const quotationId = purchaseOrder?.quotationId;
    if (quotationId) {
      return this.getIncidentQuotations().find(
        quotation =>
          quotation?.id === quotationId ||
          (quotation as any)?.quotationId === quotationId
      );
    }

    const rawQuotation = (purchaseOrder as any)?.fmQuotation;
    if (Array.isArray(rawQuotation)) {
      return rawQuotation[0];
    }

    return rawQuotation;
  }

  private resolvePurchaseOrderForQuotationLine(
    location: any,
    quotation?: FmQuotation | undefined
  ): FmPurchaseOrder | undefined {
    if (
      location?.purchaseOrder &&
      this.doesPurchaseOrderMatchLocationQuotation(
        location,
        location.purchaseOrder,
        quotation
      )
    ) {
      return location.purchaseOrder as FmPurchaseOrder;
    }

    const incidentPurchaseOrders = this.task?.incident?.fmPurchaseOrder || [];
    const purchaseOrderId = location?.purchaseOrderId;

    if (purchaseOrderId) {
      const purchaseOrderById = incidentPurchaseOrders.find(
        purchaseOrder => purchaseOrder?.id === purchaseOrderId
      );

      if (
        this.doesPurchaseOrderMatchLocationQuotation(
          location,
          purchaseOrderById,
          quotation
        )
      ) {
        return purchaseOrderById;
      }
    }

    const quotationId =
      location?.quotationId || quotation?.id || (quotation as any)?.quotationId;

    const quotationPurchaseOrders = incidentPurchaseOrders.filter(
      purchaseOrder => purchaseOrder?.quotationId === quotationId
    );

    if (quotationPurchaseOrders.length === 1) {
      return quotationPurchaseOrders[0];
    }

    const archObjId = location?.archObjId;
    if (archObjId) {
      const purchaseOrderByArchObj = quotationPurchaseOrders.find(
        purchaseOrder =>
          (purchaseOrder?.fmPurchaseOrderLine || []).some(
            purchaseOrderLine => purchaseOrderLine?.archObjId === archObjId
          ) ||
          (purchaseOrder?.fmQuotationLine || []).some(
            quotationLine => quotationLine?.archObjId === archObjId
          )
      );

      if (purchaseOrderByArchObj) {
        return purchaseOrderByArchObj;
      }
    }

    return quotationPurchaseOrders[0];
  }

  private doesPurchaseOrderMatchLocationQuotation(
    location: any,
    purchaseOrder?: FmPurchaseOrder | null,
    quotation?: FmQuotation | undefined
  ): boolean {
    if (!purchaseOrder) {
      return false;
    }

    const quotationId =
      location?.quotationId || quotation?.id || (quotation as any)?.quotationId;

    if (!quotationId) {
      return true;
    }

    return purchaseOrder?.quotationId === quotationId;
  }

  private isAddendumQuotation(quotation: FmQuotation): boolean {
    return isAddendumQuotationByType(
      quotation,
      this.quotationService.addendumOfferTypeId
    );
  }

  private isAcceptedAddendumStatusReason(
    statusReason?: string | null
  ): boolean {
    return isAcceptedAddendumStatusReasonValue(statusReason);
  }

  private getAcceptedAddendumServiceRegistrationLocations(
    existingServiceRegistrationLocations: any[] = []
  ): any[] {
    const documentsByQuotationLineId =
      getServiceRegistrationDocumentsByQuotationLineId(
        this.task,
        this.task?.configurationTask?.defaultDocumentTypeId
      );

    const existingAddendumServiceRegistrationLocations = (
      existingServiceRegistrationLocations || []
    ).filter(
      location => !!(location as any)?.isAddendumServiceRegistrationPosition
    );

    if (existingAddendumServiceRegistrationLocations.length > 0) {
      const enrichedExistingAddendumLocations =
        existingAddendumServiceRegistrationLocations.map(location => {
          const previousPurchaseOrder = location?.purchaseOrder;
          const hasMatchingExistingPurchaseOrder =
            this.doesPurchaseOrderMatchLocationQuotation(
              location,
              previousPurchaseOrder
            );
          const purchaseOrder =
            this.resolvePurchaseOrderForQuotationLine(location);
          const previousPurchaseOrderCompletionDate =
            previousPurchaseOrder?.completionDate;
          const currentCompletionDate =
            location?.serviceRegistrationCompletionDate;
          const usesMismatchedPurchaseOrderCompletionDate =
            !hasMatchingExistingPurchaseOrder &&
            !!previousPurchaseOrderCompletionDate &&
            currentCompletionDate === previousPurchaseOrderCompletionDate;

          return {
            ...location,
            purchaseOrder,
            purchaseOrderId:
              location?.purchaseOrderId || purchaseOrder?.id || null,
            serviceRegistrationDocumentationFiles:
              location?.serviceRegistrationDocumentationFiles?.length > 0
                ? location.serviceRegistrationDocumentationFiles
                : documentsByQuotationLineId.get(
                    (location?.quotationLineId || location?.id || '') as string
                  ) || [],
            serviceRegistrationCompletionDate:
              usesMismatchedPurchaseOrderCompletionDate
                ? null
                : currentCompletionDate ||
                  (location?.serviceReported
                    ? purchaseOrder?.completionDate || null
                    : null),
          };
        });

      return prepareServiceRegistrationLocations(
        enrichedExistingAddendumLocations,
        {
          includePurchaseOrderCompletionDateFallback: false,
        }
      );
    }

    const latestAddendumQuotation = this.getLatestAddendumQuotation();
    const fallbackStatusReason =
      latestAddendumQuotation?.statusReason?.defaultName;
    const latestAddendumQuotationId =
      latestAddendumQuotation?.id ||
      (latestAddendumQuotation as any)?.quotationId;

    const sourceAddendumLocations =
      this.editedLocations.length > 0
        ? this.editedLocations
        : this.getLatestAddendumQuotationLines();

    const acceptedAddendumLocations = sourceAddendumLocations.filter(location =>
      this.isAcceptedAddendumStatusReason(
        (location as any)?.addendumStatusReason || fallbackStatusReason
      )
    );

    if (acceptedAddendumLocations.length === 0) {
      return [];
    }

    return prepareServiceRegistrationLocations(
      acceptedAddendumLocations.map(location => {
        const purchaseOrder = this.resolvePurchaseOrderForQuotationLine(
          location,
          latestAddendumQuotation
        );

        return {
          ...location,
          isAddendumServiceRegistrationPosition: true,
          purchaseOrder,
          purchaseOrderId:
            (location as any)?.purchaseOrderId || purchaseOrder?.id || null,
          quotationId:
            (location as any)?.quotationId || latestAddendumQuotationId || null,
          quotationLineId: (location as any)?.quotationLineId || location?.id,
          serviceRegistrationCompletionDate:
            (location as any)?.serviceRegistrationCompletionDate ||
            ((location as any)?.serviceReported
              ? purchaseOrder?.completionDate || null
              : null),
          serviceRegistrationDocumentationFiles:
            (location as any)?.serviceRegistrationDocumentationFiles?.length > 0
              ? (location as any)?.serviceRegistrationDocumentationFiles
              : documentsByQuotationLineId.get(
                  String(
                    (location as any)?.quotationLineId || location?.id || ''
                  )
                ) || [],
        };
      }),
      {
        includePurchaseOrderCompletionDateFallback: false,
      }
    );
  }

  private getOrderNumberList(locations: any[] = []): string {
    return (locations || [])
      .map(
        (location: any) =>
          location?.purchaseOrder?.orderNumber ?? location?.orderNumber
      )
      .filter((orderNumber): orderNumber is string => !!orderNumber)
      .filter(
        (orderNumber, index, orderNumbers) =>
          orderNumbers.indexOf(orderNumber) === index
      )
      .join(', ');
  }

  private getAddendumLocationsForDisplay(locations: any[] = []): any[] {
    const latestAddendumQuotation = this.getLatestAddendumQuotation();

    return (locations || []).map((location: any) => {
      const resolvedPurchaseOrder =
        location?.purchaseOrder ||
        this.resolvePurchaseOrderForQuotationLine(
          location,
          latestAddendumQuotation
        );

      return {
        ...location,
        purchaseOrder: resolvedPurchaseOrder || location?.purchaseOrder,
        orderNumber:
          location?.orderNumber ||
          resolvedPurchaseOrder?.orderNumber ||
          location?.purchaseOrder?.orderNumber,
      };
    });
  }

  private createServiceRegistrationEditableField(
    baseField: any,
    locations: any[],
    serviceRegistrationColumns: any[],
    options?: {
      orderNumberFallback?: string;
      locationSumLabel?: string;
      showAddendumStatusReason?: boolean;
      addendumStatusReason?: string;
      archObjIdsWithRejections?: Set<string>;
    }
  ): any {
    return {
      ...baseField,
      type: 'locations-expandable-editable',
      props: {
        enableLineManagementForServiceRegistration:
          !!this.task?.incident?.fmServiceRequestExternal
            ?.frameworkContractId && !this.isDummyFrameworkContract,
        ...(baseField?.props || {}),
        equipmentColumns: this.equipmentService.buildEquipmentColumns({
          includeDocumentation: true,
        }),
        locations,
        orderNumber:
          this.getOrderNumberList(locations) ||
          options?.orderNumberFallback ||
          '-',
        serviceLineColumns: serviceRegistrationColumns,
        archObjIdsWithRejections: options?.archObjIdsWithRejections,
        hideQuantityEdit: true,
        hideUnitPriceEdit: true,
        hideComment: true,
        sumQuantityField: 'quantityProvided',
        locationSumLabel:
          options?.locationSumLabel ||
          baseField?.props?.locationSumLabel ||
          this.translateService.instant(
            'taskmodule.task.offer.order_price_location'
          ),
        receiptLocationSumLabel: this.translateService.instant(
          'taskmodule.task.offer.service_receipt_location_sum_label'
        ),
        receiptTotalSumLabel: this.translateService.instant(
          'taskmodule.task.offer.service_receipt_total_sum_label'
        ),
        showAddendumStatusReason: options?.showAddendumStatusReason || false,
        addendumStatusReason: options?.addendumStatusReason,
        documentUploadConfigurationTaskId:
          this.task?.configurationTaskId || null,
        defaultDocumentTypeName: this.defaultEquipmentDocumentTypeName,
        tooltipSelectDocument: this.tooltipSelectDocument,
        tooltipUploadDocument: this.tooltipUploadDocument,
        allowedFileExtensions: this.task3And7AllowedFileExtensions,
        maxUploadFiles: 10,
        incidentClassName:
          this.task?.incident?.incidentClass?.incidentClass || '',
        incidentClassId:
          this.task?.incident?.incidentClass?.incidentClassId || '',
        serviceRegistrationSubmitButtonLabel: this.translateService.instant(
          'taskmodule.task.service_registration.label_send'
        ),
        disableEquipmentDocumentationUpload: false,
        expandPendingServiceRegistrationOnly: true,
        onServiceRegistrationSubmit: (group?: { rows?: any[] }) =>
          this.updateServiceRegistration(group),
        expandAllPanels: true,
        onChange: () => this.modelOnChange(),
      },
    };
  }

  initializeContactUsForm(): void {
    this.formFieldsContactUs = [
      {
        fieldGroup: [
          {
            key: 'subject',
            type: 'input',
            props: {
              label: `${this.translateService.instant(
                'location.myLocation.location_notification.label__subject'
              )}:`,
              required: true,
            },
            validation: {
              messages: {
                required: this.translateService.instant('formErrors.required', {
                  label: this.translateService.instant(
                    'location.myLocation.location_notification.label__subject'
                  ),
                }),
              },
            },
          },
          {
            key: 'content',
            type: 'textarea',
            props: {
              label: `${this.translateService.instant(
                'ticket.summary.contact.content'
              )}:`,
              required: true,
              rows: 5,
            },
            validation: {
              messages: {
                required: this.translateService.instant('formErrors.required', {
                  label: this.translateService.instant(
                    'ticket.summary.contact.content'
                  ),
                }),
              },
            },
          },
        ],
      },
    ];
  }

  validateForm() {
    if (this.formContactUs.valid) {
      this.submitContactUsForm();
    }
  }

  private resetFormContactUs() {
    this.formContactUs = new FormGroup({});
    this.formModelContactUs = {} as IContactForm;
    this.initializeContactUsForm();
  }

  submitContactUsForm() {
    this.isLoading = true;
    this.cd.detectChanges();
    from(this.mapFormToRequest())
      .pipe(
        switchMap(request =>
          this.incidentClient.sendIncidentCommunication(request).pipe(
            finalize(() => {
              this.isLoading = false;
              this.cd.detectChanges();
            })
          )
        )
      )
      .subscribe({
        next: () => {
          this.toastr.success(
            this.translateService.instant(
              'location.myLocation.location_notification.success_message'
            )
          );
          this.resetFormContactUs();
        },
        error: () => {
          this.toastr.error(
            this.translateService.instant(
              'location.myLocation.location_notification.error_message'
            )
          );
        },
      });
  }

  private async mapFormToRequest(): Promise<SendIncidentCommunicationRequest> {
    return {
      incidentId: this.task?.incident?.incidentId,
      incidentClass: this.task?.incident?.incidentClass?.incidentClass,
      subject: this.formModelContactUs.subject,
      message: this.formModelContactUs.content,
    };
  }

  exportToExcel() {
    this.canDownload = false;

    const shouldUseDummyDisplayPrices =
      this.isDummyFrameworkContract && this.isTask3EvaluateOfferInquiry;

    const locations: FmIncidentServiceLine[] | FmQuotationRequestLine[] =
      shouldUseDummyDisplayPrices
        ? this.locations.map(location => ({
            ...location,
            unitPrice: (location as any).priceNegotiated
              ? parseFloat(String(location.unitPrice)) || 0
              : 0,
          }))
        : this.locations;
    const fmIncidentArchObj = this.task?.incident?.fmIncidentArchObj || [];

    const formOverrides: FormOverrides = {
      result: this.formModel.result,
      validUntil: this.isTask3EvaluateOfferInquiry
        ? this.formModel.validUntil
        : undefined,
    };

    // or from existing Quotation in database
    let quotationLines: any[] = [];
    if (this.isTask3EvaluateOfferInquiry) {
      if (this.editedLocations.length > 0) {
        quotationLines = [...this.editedLocations].sort(
          (a, b) => (a.recordNumber || 0) - (b.recordNumber || 0)
        );
      } else {
        const quotationRequest = this.task?.incident?.fmQuotationRequest?.[0];
        const latestQuotation = quotationRequest?.fmQuotation?.[0];
        quotationLines = [...(latestQuotation?.fmQuotationLine || [])].sort(
          (a, b) => (a.recordNumber || 0) - (b.recordNumber || 0)
        );
      }
    } else if (
      this.isTask7ExecuteOptionalService &&
      this.editedLocations.length > 0
    ) {
      quotationLines = [...this.editedLocations].sort(
        (a, b) => (a.recordNumber || 0) - (b.recordNumber || 0)
      );
    }

    const hidePricesForLocations = false;

    const hidePurchasingInformation = this.isTask3EvaluateOfferInquiry;

    const hideAuxilaryAccountAssignment =
      this.isTask2EvaluateOffersAndCreateSuppliers ||
      this.isTask3EvaluateOfferInquiry;

    const showLocationsAfterPurchasingInfo =
      this.isTask2EvaluateOffersAndCreateSuppliers;

    // Für Aufgabe 2 & 3 keine Kommentar-Spalte
    let columnsForExport = this.serviceLineColumns;
    if (
      this.isTask2EvaluateOffersAndCreateSuppliers ||
      this.isTask3EvaluateOfferInquiry
    ) {
      columnsForExport = this.serviceLineColumns.filter(
        col => col.field !== 'serviceProviderComment'
      );
    }

    if (this.isTask2EvaluateOffersAndCreateSuppliers) {
      const totalPriceIndex = columnsForExport.findIndex(
        col => col.field === 'totalPrice'
      );
      const priceNegotiatedColumn: any = {
        header: this.translateService.instant(
          'taskmodule.task.offer.negotiated_price'
        ),
        field: 'priceNegotiated',
        sortable: false,
        width: '140px',
        formatter: (row: any) =>
          row?.priceNegotiated
            ? this.translate('label__choice_yes')
            : this.translate('label__choice_no'),
      };

      if (totalPriceIndex !== -1) {
        columnsForExport.splice(totalPriceIndex + 1, 0, priceNegotiatedColumn);
      } else {
        columnsForExport.push(priceNegotiatedColumn);
      }
    }

    const quotationLineColumnsForExport = this.isTask3EvaluateOfferInquiry
      ? this.serviceLineColumns
      : columnsForExport;

    const quotationLinesLabel = this.isTask7ExecuteOptionalService
      ? this.translateService.instant(
          'taskmodule.task.offer.locations_addendum_positions'
        )
      : this.translateService.instant(
          'taskmodule.task.offer.locations_offer_positions'
        );

    this.taskExcelExportService.exportOplExtTask(
      this.entity.entity,
      locations,
      fmIncidentArchObj,
      formOverrides,
      'Ticketdetails OPL Extern.xlsx',
      'Ticketdetails OPL Extern',
      quotationLines.length > 0 ? quotationLines : undefined,
      quotationLinesLabel,
      hidePricesForLocations,
      hidePurchasingInformation,
      hideAuxilaryAccountAssignment,
      showLocationsAfterPurchasingInfo,
      columnsForExport,
      quotationLineColumnsForExport,
      false,
      this.isTask11SubmitInvoiceToScanCenter
        ? this.translateService.instant(
            'taskmodule.task.offer.locations_facturation_positions'
          )
        : this.isTask7ExecuteOptionalService
          ? this.translateService.instant(
              'taskmodule.task.offer.locations_offer_positions_order'
            )
          : this.isTask3EvaluateOfferInquiry
            ? this.translateService.instant(
                'taskmodule.task.offer.locations_offer'
              )
            : this.translateService.instant(
                'taskmodule.shared.label__locations'
              ),
      this.isTask7ExecuteOptionalService
        ? `${this.translateService.instant('taskmodule.task.offer.order_price_location')}:`
        : undefined,
      this.isTask7ExecuteOptionalService
        ? `${this.translateService.instant('taskmodule.task.offer.order_sum_total')}:`
        : undefined,
      this.isTask7ExecuteOptionalService
        ? `${this.translateService.instant('taskmodule.task.offer.total_addendum_positions_label')}:`
        : undefined,
      this.isTask7ExecuteOptionalService
        ? `${this.translateService.instant('taskmodule.task.offer.total_addendum_positions_label')}:`
        : undefined
    );

    this.canDownload = true;
  }

  onSubmitOffer() {
    if (
      this.isDummyFrameworkContract &&
      this.isTask3EvaluateOfferInquiry &&
      this.units.length === 0
    ) {
      this.unitClient
        .getUnits()
        .pipe(first())
        .subscribe((result: any) => {
          this.units = result.filter((unit: FmUnit) => unit.isPrimary === true);
          this.openSubmitOfferDialog();
        });
    } else if (
      !this.isDummyFrameworkContract &&
      this.isTask3EvaluateOfferInquiry &&
      this.frameworkContractLineItems.length === 0
    ) {
      const frameworkContractId =
        this.task?.incident?.fmServiceRequestExternal?.frameworkContractId;
      this.frameworkContractClient
        .getFrameworkContractLineItems(frameworkContractId.trim())
        .pipe(first())
        .subscribe((result: any) => {
          this.frameworkContractLineItems = result;
          this.openSubmitOfferDialog();
        });
    } else {
      this.openSubmitOfferDialog();
    }
  }

  private openSubmitOfferDialog() {
    const baseLocations =
      this.editedLocations.length > 0 ? this.editedLocations : this.locations;

    const sortedRequests = [
      ...(this.task?.incident?.fmQuotationRequest || []),
    ].sort(
      (a, b) =>
        new Date(b.changeDate || 0).getTime() -
        new Date(a.changeDate || 0).getTime()
    );
    const offerDate = sortedRequests[0]?.changeDate
      ? new Date(sortedRequests[0].changeDate)
      : undefined;

    const locationsForDialog =
      this.isDummyFrameworkContract && this.editedLocations.length === 0
        ? baseLocations.map(location => {
            const isPriceNegotiated =
              (location as any).priceNegotiated ?? false;

            return {
              ...location,
              priceNegotiated: isPriceNegotiated,
              unitPrice: isPriceNegotiated
                ? parseFloat(String(location.unitPrice)) || 0
                : 0,
            };
          })
        : baseLocations;

    const dialogRef = this.dialog.open(SubmitOfferDialogComponent, {
      width: '90vw',
      maxWidth: '1200px',
      maxHeight: '90vh',
      data: {
        title: this.translateService.instant(
          'taskmodule.task.offer.dialog_title'
        ),
        submitButtonLabel: this.translateService.instant(
          'taskmodule.task.offer.submit_button'
        ),
        locations: locationsForDialog,
        serviceLineColumns: this.serviceLineColumns,
        fmIncidentArchObj: this.task?.incident?.fmIncidentArchObj || [],
        isDummyFrameworkContract: this.isDummyFrameworkContract,
        units: this.units || [],
        hideUnitPriceEdit: !this.isDummyFrameworkContract,
        frameworkContractLineItems: this.frameworkContractLineItems || [],
        enableManualLineManagement: !this.isDummyFrameworkContract,
        equipmentByArchObjId: this.equipmentService.buildEquipmentByArchObjId(
          this.task
        ),
        equipmentColumns: this.equipmentService.buildEquipmentColumns({
          includeDocumentation: false,
        }),
        offerDate,
        expandFirstLocationOnInit: this.isTask3EvaluateOfferInquiry,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(updatedLocations => {
      if (updatedLocations) {
        this.editedLocations = [...updatedLocations].sort(
          (a, b) => (a.recordNumber || 0) - (b.recordNumber || 0)
        );
        this.showEditedLocations = true;

        // Enable save button only if offer has changed or form has changed
        const offerChanged = !isEqual(
          this.editedLocations,
          this.editedLocationsInit
        );
        const formChanged = !isEqual(this.formModel, this.formModelInit);
        this.isSaveButtonEnabled = offerChanged || formChanged;

        this.addEditedLocationsToForm();
        this.cd.detectChanges();
      }
    });
  }

  onSubmitAddendumOffer() {
    if (
      this.isDummyFrameworkContract &&
      this.isTask7ExecuteOptionalService &&
      this.units.length === 0
    ) {
      this.unitClient
        .getUnits()
        .pipe(first())
        .subscribe((result: any) => {
          this.units = result.filter((unit: FmUnit) => unit.isPrimary === true);
          this.openSubmitAddendumOfferDialog();
        });
    } else if (
      !this.isDummyFrameworkContract &&
      this.isTask7ExecuteOptionalService &&
      this.frameworkContractLineItems.length === 0
    ) {
      const frameworkContractId =
        this.task?.incident?.fmServiceRequestExternal?.frameworkContractId;
      this.frameworkContractClient
        .getFrameworkContractLineItems(frameworkContractId.trim())
        .pipe(first())
        .subscribe((result: any) => {
          this.frameworkContractLineItems = result;
          this.openSubmitAddendumOfferDialog();
        });
    } else {
      this.openSubmitAddendumOfferDialog();
    }
  }

  private openSubmitAddendumOfferDialog() {
    // For addendum offer: always keep all original location groups visible
    const sourceLocationsForGroups =
      this.locations.length > 0 ? this.locations : this.editedLocations;
    const addendumStatusReason = this.getLatestAddendumStatusReason();

    // Create placeholder groups by archObjId
    const locationsByArchObjId = new Map<string, any>();

    for (const location of sourceLocationsForGroups) {
      const archObjId =
        location.archObjId || location.archObj?.archObjId || 'unknown';
      if (!locationsByArchObjId.has(archObjId)) {
        locationsByArchObjId.set(archObjId, {
          archObjId,
          archObj: location.archObj,
          isGroupPlaceholder: true,
          addendumStatusReason: addendumStatusReason,
        });
      }
    }

    // Show previous inputs in dialog if exists
    const existingAddendumLines = (this.editedLocations || [])
      .filter(
        location =>
          location.recordNumber !== null && location.recordNumber !== undefined
      )
      .map(location => ({
        ...location,
        addendumStatusReason:
          (location as any).addendumStatusReason || addendumStatusReason,
      }));

    const locationsForDialog = [
      ...Array.from(locationsByArchObjId.values()),
      ...existingAddendumLines,
    ];

    const dialogRef = this.dialog.open(SubmitOfferDialogComponent, {
      width: '90vw',
      maxWidth: '1200px',
      maxHeight: '90vh',
      data: {
        title: this.translateService.instant(
          'taskmodule.task.offer.addendum_offer'
        ),
        submitButtonLabel: this.translateService.instant(
          'taskmodule.task.offer.addendum_offer'
        ),
        locations: locationsForDialog,
        serviceLineColumns: this.serviceLineColumns,
        fmIncidentArchObj: this.task?.incident?.fmIncidentArchObj || [],
        isDummyFrameworkContract: this.isDummyFrameworkContract,
        units: this.units || [],
        hideUnitPriceEdit: !this.isDummyFrameworkContract,
        frameworkContractLineItems: this.frameworkContractLineItems || [],
        enableManualLineManagement: true,
        showAddendumCommentField: true,
        showAddendumStatusReason: true,
        addendumStatusReason,
        addendumComment:
          this.formModel?.serviceProviderCommentAddendum ||
          this.form.get('serviceProviderCommentAddendum')?.value ||
          '',
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.locations?.length > 0) {
        const currentNewStatus =
          this.form.get('newStatus')?.value ?? this.formModel?.newStatus;
        this.editedLocations = [...result.locations].sort(
          (a, b) => (a.recordNumber || 0) - (b.recordNumber || 0)
        );
        this.formModel = {
          ...this.formModel,
          serviceProviderCommentAddendum: result.addendumComment || '',
        };
        this.showEditedLocations = true;

        // Enable save button only if offer has changed or form has changed
        const offerChanged = !isEqual(
          this.editedLocations,
          this.editedLocationsInit
        );
        const formChanged = !isEqual(this.formModel, this.formModelInit);
        this.isSaveButtonEnabled = offerChanged || formChanged;

        this.addEditedLocationsToForm();
        this.cd.detectChanges();

        setTimeout(() => {
          this.restoreNewStatusSelection(currentNewStatus);
          this.cd.detectChanges();
        });
      }
    });
  }

  private restoreNewStatusSelection(
    statusValue: TaskStatus | null | undefined
  ) {
    if (statusValue === null || statusValue === undefined) {
      return;
    }

    this.formModel = {
      ...this.formModel,
      newStatus: statusValue,
    };

    const newStatusControl = this.form.get('newStatus');
    if (newStatusControl) {
      if (newStatusControl.value !== statusValue) {
        (newStatusControl as any).setValue(statusValue, { emitEvent: false });
      }
      return;
    }

    this.form.patchValue({ newStatus: statusValue } as any, {
      emitEvent: false,
    });
  }

  addEditedLocationsToForm() {
    const locationsIndex = this.formFields.findIndex(
      field => field.key === 'locationsExpandable'
    );

    if (locationsIndex === -1) return;

    // Entferne eventuell bereits vorhandene bearbeitete Locations
    this.formFields = this.formFields.filter(
      field => field.key !== 'editedLocationsExpandable'
    );

    const headlineKey = this.isTask7ExecuteOptionalService
      ? 'taskmodule.task.offer.locations_addendum_positions'
      : 'taskmodule.task.offer.locations_offer_positions';
    const headlineTooltipKey = this.isTask7ExecuteOptionalService
      ? 'taskmodule.task.offer.tooltip.locations.addendum_positions'
      : '';
    const totalSumKey = this.isTask7ExecuteOptionalService
      ? 'taskmodule.task.offer.total_addendum_positions_label'
      : 'taskmodule.task.offer.total_offer_positions_label';

    this.formFields.splice(locationsIndex + 1, 0, {
      key: 'editedLocationsExpandable',
      type: 'locations-expandable',
      props: {
        headline: this.translateService.instant(headlineKey),
        headlineTooltip: this.translateIfKey(headlineTooltipKey),
        locations: this.getAddendumLocationsForDisplay(this.editedLocations),
        serviceLineColumns: this.serviceLineColumns,
        fmIncidentArchObj: this.task?.incident?.fmIncidentArchObj || [],
        isDummyFrameworkContract: this.isDummyFrameworkContract,
        totalSumLabel: this.translateService.instant(totalSumKey),
        isOfferPosition: true,
        showAddendumStatusReason: this.isTask7ExecuteOptionalService,
        addendumStatusReason: this.getLatestAddendumStatusReason(),
        showAddendumCommentDisplay: this.isTask7ExecuteOptionalService,
        addendumComment: this.formModel?.serviceProviderCommentAddendum || '',
        equipmentByArchObjId: this.equipmentService.buildEquipmentByArchObjId(
          this.task
        ),
        equipmentFilterDate: (() => {
          const allPOs = this.task?.incident?.fmPurchaseOrder || [];
          const posWithLines = allPOs.filter(
            (po: any) => this.getQuotationLinesFromPurchaseOrder(po).length > 0
          );
          const quotations = posWithLines
            .map((po: any) => this.getQuotationForPurchaseOrder(po))
            .filter((q): q is any => !!q);
          const sorted = [...quotations].sort(
            (a, b) =>
              new Date(b.changeDate || 0).getTime() -
              new Date(a.changeDate || 0).getTime()
          );
          return sorted[0]?.changeDate
            ? new Date(sorted[0].changeDate)
            : undefined;
        })(),
        equipmentColumns: this.equipmentService.buildEquipmentColumns({
          includeDocumentation: false,
        }),
        disableEquipmentDocumentationUpload: true,
      },
    });
  }

  activateEditFields() {
    if (!this.isTask2EvaluateOffersAndCreateSuppliers) {
      return;
    }

    this.isTask2LineItemsEditable = true;

    this.formFields = this.formFields.map(card => ({
      ...card,
      fieldGroup: card.fieldGroup?.map(group => ({
        ...group,
        fieldGroup: (group.fieldGroup || []).map(field =>
          field.key === 'locationsTask2'
            ? {
                ...field,
                props: {
                  ...field.props,
                  readOnlyMode: false,
                  expandAllPanels: true,
                },
              }
            : field
        ),
      })),
    }));

    this.cd.detectChanges();
  }

  addServiceRegistrationFields() {
    if (!this.isTask7ExecuteOptionalService) {
      return;
    }

    const locationsIndex = this.formFields.findIndex(
      field => field.key === 'locationsExpandable'
    );

    if (locationsIndex === -1) {
      return;
    }

    const wasServiceRegistrationModeActive =
      this.isServiceRegistrationModeActive;
    this.isServiceRegistrationModeActive = true;

    const existingServiceRegistrationLocations =
      this.serviceRegistrationLocations.length > 0
        ? prepareServiceRegistrationLocations(
            this.serviceRegistrationLocations,
            {
              includePurchaseOrderCompletionDateFallback: true,
            }
          )
        : [];

    const existingMainServiceRegistrationLocations =
      existingServiceRegistrationLocations.filter(
        location => !(location as any)?.isAddendumServiceRegistrationPosition
      );

    const mainServiceRegistrationLocations =
      existingMainServiceRegistrationLocations.length > 0
        ? existingMainServiceRegistrationLocations
        : prepareServiceRegistrationLocations(this.locations || [], {
            includePurchaseOrderCompletionDateFallback: true,
          });

    const acceptedAddendumServiceRegistrationLocations =
      this.getAcceptedAddendumServiceRegistrationLocations(
        existingServiceRegistrationLocations
      );

    this.serviceRegistrationLocations = [
      ...mainServiceRegistrationLocations,
      ...acceptedAddendumServiceRegistrationLocations,
    ];

    if (!wasServiceRegistrationModeActive) {
      this.serviceRegistrationLocationsInit = cloneDeep(
        this.serviceRegistrationLocations
      );
    }

    const serviceRegistrationColumns = [
      {
        header: this.translateService.instant('taskmodule.task.offer.number'),
        field: 'recordNumber',
        sortable: true,
        width: '60px',
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.description'
        ),
        field: 'description',
        sortable: true,
        formatter: (row: any) => row.name || row.description || '',
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.order_quantity'
        ),
        field: 'quantity',
        sortable: true,
        formatter: (row: any) => row.quantity ?? 0,
      },
      {
        header: this.translateService.instant('taskmodule.task.offer.unit'),
        field: 'unit.name',
        sortable: true,
        formatter: (row: any) => row.unit?.name || '',
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.unit_price'
        ),
        field: 'unitPrice',
        sortable: true,
        formatter: (row: any) => `${row.unitPrice ?? 0} €`,
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.order_price'
        ),
        field: 'totalPrice',
        sortable: true,
        formatter: (row: any) => {
          const quantity = parseFloat(String(row?.quantity)) || 0;
          const unitPrice = parseFloat(String(row?.unitPrice)) || 0;
          return `${(quantity * unitPrice).toFixed(2)} €`;
        },
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.quantity_service_receipt'
        ),
        field: 'quantityProvided',
        sortable: false,
        width: '120px',
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.service_receipt_billable'
        ),
        field: 'serviceRegistrationBillableValue',
        sortable: false,
        width: '130px',
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.documentation'
        ),
        field: 'serviceRegistrationDocumentation',
        sortable: false,
        width: '260px',
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.comment_service_receipt'
        ),
        field: 'serviceRegistrationCommentExternal',
        sortable: false,
        width: '280px',
      },
      {
        header: this.translateService.instant('taskmodule.task.offer.status'),
        field: 'serviceReported',
        sortable: false,
        width: '130px',
      },
    ];

    serviceRegistrationColumns.splice(
      serviceRegistrationColumns.length - 2,
      0,
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.rejection_reason'
        ),
        field: 'serviceReceiptCommentInternal',
        sortable: false,
        formatter: (row: any) => row?.serviceReceiptCommentInternal || '',
      }
    );

    const mainArchObjIdsWithRejections = new Set<string>();
    for (const location of mainServiceRegistrationLocations) {
      const archObjId = location?.archObjId || location?.archObj?.archObjId;
      if (
        archObjId &&
        location?.serviceAcceptanceStatus?.defaultName === 'Abgelehnt' &&
        !this.parseDateStringToDate(location?.purchaseOrder?.completionDate)
      ) {
        mainArchObjIdsWithRejections.add(archObjId);
      }
    }

    const addendumArchObjIdsWithRejections = new Set<string>();
    for (const location of acceptedAddendumServiceRegistrationLocations) {
      const archObjId = location?.archObjId || location?.archObj?.archObjId;
      if (
        archObjId &&
        location?.serviceAcceptanceStatus?.defaultName === 'Abgelehnt' &&
        !this.parseDateStringToDate(location?.purchaseOrder?.completionDate)
      ) {
        addendumArchObjIdsWithRejections.add(archObjId);
      }
    }

    const existingLocationsField = this.formFields[locationsIndex];
    const newField = this.createServiceRegistrationEditableField(
      existingLocationsField,
      mainServiceRegistrationLocations,
      serviceRegistrationColumns,
      {
        orderNumberFallback: existingLocationsField?.props?.orderNumber,
        archObjIdsWithRejections: mainArchObjIdsWithRejections,
      }
    );

    // Create a new array reference so Formly processes this change exactly
    // once and doesn't re-render the component on subsequent CD cycles
    const newFormFields = [...this.formFields];
    newFormFields[locationsIndex] = newField;

    const editedLocationsIndex = newFormFields.findIndex(
      field => field.key === 'editedLocationsExpandable'
    );

    if (
      editedLocationsIndex !== -1 &&
      acceptedAddendumServiceRegistrationLocations.length > 0
    ) {
      const existingEditedLocationsField = newFormFields[editedLocationsIndex];
      newFormFields[editedLocationsIndex] =
        this.createServiceRegistrationEditableField(
          existingEditedLocationsField,
          acceptedAddendumServiceRegistrationLocations,
          serviceRegistrationColumns,
          {
            locationSumLabel: this.translateService.instant(
              'taskmodule.task.offer.total_addendum_positions_label'
            ),
            showAddendumStatusReason: true,
            addendumStatusReason: this.getLatestAddendumStatusReason(),
            archObjIdsWithRejections: addendumArchObjIdsWithRejections,
          }
        );
    }

    this.formFields = newFormFields;

    this.cd.detectChanges();
  }

  private getNewStatusOptions(): any[] {
    return this.statusOptionsService.build(this.buildStatusOptionsContext());
  }

  private updateNewStatusFieldOptions(fields: FormlyFieldConfig[] = []) {
    this.statusOptionsService.refreshFields(
      fields,
      this.buildStatusOptionsContext()
    );
  }

  private buildStatusOptionsContext(): StatusOptionsContext {
    return {
      isTask7ExecuteOptionalService: this.isTask7ExecuteOptionalService,
      isTask11SubmitInvoiceToScanCenter: this.isTask11SubmitInvoiceToScanCenter,
      hasEditedLocations: this.editedLocations.length > 0,
      hasExistingAddendumOffer: this.hasExistingAddendumOffer,
    };
  }

  private translateIfKey(key?: string | null): string | undefined {
    return translateIfTooltipKey(
      (translationKey: string) => this.translateService.instant(translationKey),
      key
    );
  }

  private getTaskTooltipKey(base: string): string | null {
    return buildTaskTooltipKey(
      base,
      this.isTask2EvaluateOffersAndCreateSuppliers,
      this.isTask3EvaluateOfferInquiry,
      this.isTask7ExecuteOptionalService,
      this.isTask11SubmitInvoiceToScanCenter
    );
  }
}
